"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Css: ['css', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-14,9.875a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm2.927-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,11.8,8.376h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Zm5,0,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H15.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,16.8,8.376h1.7a.625.625,0,0,1,0,1.25H16.8a.678.678,0,0,0-.376,1.242Z']],
  Css1: ['css-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM7.5,18.876a.625.625,0,0,1,0,1.25,4.625,4.625,0,0,1,0-9.25.625.625,0,0,1,0,1.25,3.375,3.375,0,0,0,0,6.75Zm3.305-4.422,1.949.975a2.479,2.479,0,0,1-1.108,4.7H9.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.549-2.329l-1.95-.974a2.48,2.48,0,0,1,1.109-4.7H13.5a.625.625,0,0,1,0,1.25H11.354a1.229,1.229,0,0,0-.549,2.328Zm6,0,1.949.975a2.479,2.479,0,0,1-1.108,4.7H15.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.549-2.329l-1.95-.974a2.48,2.48,0,0,1,1.109-4.7H19.5a.625.625,0,0,1,0,1.25H17.354a1.229,1.229,0,0,0-.549,2.328Z']],
  CPlusPlus1: ['c-plus-plus-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM7.5,18.876a.625.625,0,0,1,0,1.25,4.625,4.625,0,0,1,0-9.25.625.625,0,0,1,0,1.25,3.375,3.375,0,0,0,0,6.75Zm6-2.75H12.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H9.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V13.5a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H13.5a.625.625,0,0,1,0,1.25Zm6,0H18.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,1,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H15.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V13.5a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H19.5a.625.625,0,0,1,0,1.25Z']],
  Dat: ['dat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.876.876,0,0,0,12,9.626Z', 'M6.456,9.82a.249.249,0,0,0-.331.239v3.883a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,7.875,12,2.237,2.237,0,0,0,6.456,9.82Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM5.5,15.626A.625.625,0,0,1,4.875,15V9A.625.625,0,0,1,5.5,8.376a3.625,3.625,0,0,1,0,7.25ZM14.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,14.125,10.5ZM19.5,9.626H18.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9.876a.25.25,0,0,0-.25-.25H15.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Z']],
  Dmg: ['dmg', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.456,9.82a.249.249,0,0,0-.331.239v3.883a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,7.875,12,2.237,2.237,0,0,0,6.456,9.82Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM5.5,15.626A.625.625,0,0,1,4.875,15V9A.625.625,0,0,1,5.5,8.376a3.625,3.625,0,0,1,0,7.25ZM14.125,15a.625.625,0,0,1-1.25,0V12.074c0-.154-.15-.134-.224.021l-.092.185a.65.65,0,0,1-1.118,0s-.047-.092-.107-.214-.209-.117-.209.008V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s.72,1.429.786,1.571a.173.173,0,0,0,.311,0l.785-1.569A.625.625,0,0,1,14.125,9Zm5-4a.625.625,0,0,1-1.25,0v-.5a.875.875,0,1,0-1.75,0v3a.875.875,0,0,0,1.718.237c.01-.036.033-.112-.085-.112H17.5a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625v.5a2.125,2.125,0,0,1-4.25,0v-3a2.125,2.125,0,1,1,4.25,0Z']],
  Dmg1: ['dmg-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.478,0H1.522A1.524,1.524,0,0,0,0,1.523V22.478A1.524,1.524,0,0,0,1.522,24H22.478A1.524,1.524,0,0,0,24,22.478V1.523A1.524,1.524,0,0,0,22.478,0ZM3.5,20.126a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25ZM14.125,19.5a.625.625,0,1,1-1.25,0V14.777c0-.153-.255-.119-.307-.015l-.509,1.018a.625.625,0,0,1-1.118,0s-.452-.909-.526-1.052-.29-.121-.29.014V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,1.184-.279l1.217,2.434a.25.25,0,0,0,.448,0l1.217-2.434a.625.625,0,0,1,1.184.279Zm3.375-.625A1.377,1.377,0,0,0,18.875,17.5s.036-.375-.258-.375H18a.625.625,0,0,1,0-1.25h1.5a.625.625,0,0,1,.625.625v1a2.625,2.625,0,1,1-5.25,0v-4a2.625,2.625,0,1,1,5.25,0,.625.625,0,0,1-1.25,0,1.375,1.375,0,1,0-2.75,0v4A1.377,1.377,0,0,0,17.5,18.876Z', 'M4.125,12.5V18.5a.251.251,0,0,0,.312.245,3.375,3.375,0,0,0,0-6.485A.251.251,0,0,0,4.125,12.5Z']],
  Exe1: ['exe-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM7,14.876a.625.625,0,0,1,0,1.25H5.375a.25.25,0,0,0-.25.25V18A.875.875,0,0,0,6,18.876H8.5a.625.625,0,0,1,0,1.25H6A2.125,2.125,0,0,1,3.875,18V13A2.124,2.124,0,0,1,6,10.876H8.5a.625.625,0,0,1,0,1.25H6A.875.875,0,0,0,5.125,13v1.625a.25.25,0,0,0,.25.25Zm8.059,4.346a.625.625,0,1,1-1.118.558l-1.217-2.435a.25.25,0,0,0-.448,0L11.059,19.78a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.8-3.609a.252.252,0,0,0,0-.224l-1.8-3.609a.625.625,0,1,1,1.118-.558l1.217,2.435a.251.251,0,0,0,.448,0l1.217-2.435a.625.625,0,0,1,1.118.558l-1.8,3.609a.252.252,0,0,0,0,.224ZM19,14.876a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V18a.875.875,0,0,0,.875.875h2.5a.625.625,0,0,1,0,1.25H18A2.125,2.125,0,0,1,15.875,18V13A2.124,2.124,0,0,1,18,10.876h2.5a.625.625,0,0,1,0,1.25H18a.875.875,0,0,0-.875.875v1.625a.25.25,0,0,0,.25.25Z']],
  Csv1: ['csv-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM7.5,18.876a.625.625,0,0,1,0,1.25,4.625,4.625,0,0,1,0-9.25.625.625,0,0,1,0,1.25,3.375,3.375,0,0,0,0,6.75Zm3.3-4.409,1.95.975a2.479,2.479,0,0,1-1.108,4.7H9.5a.625.625,0,0,1,0-1.25h2.146A1.229,1.229,0,0,0,12.2,16.56l-1.95-.975a2.479,2.479,0,0,1,1.109-4.7H13.5a.625.625,0,0,1,0,1.25H11.354a1.229,1.229,0,0,0-.55,2.328Zm9.321-.668a9.79,9.79,0,0,1-2.137,6.092.624.624,0,0,1-.976,0A9.784,9.784,0,0,1,14.875,13.8V11.5a.625.625,0,1,1,1.25,0v2.3a8.53,8.53,0,0,0,1.154,4.275.26.26,0,0,0,.442,0A8.535,8.535,0,0,0,18.875,13.8V11.5a.625.625,0,1,1,1.25,0Z']],
  Dat1: ['dat-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.5,12.126A1.377,1.377,0,0,0,11.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,12.5,12.126Z', 'M5.125,12.5V18.5a.251.251,0,0,0,.312.245,3.375,3.375,0,0,0,0-6.485A.251.251,0,0,0,5.125,12.5Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM4.5,20.126a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25ZM15.125,19.5a.625.625,0,1,1-1.25,0V16.376a.25.25,0,0,0-.25-.25h-2.25a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-5.9a2.7,2.7,0,0,1,2.1-2.678A2.629,2.629,0,0,1,15.125,13.5ZM20.5,12.126H19.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0V12.376a.25.25,0,0,0-.25-.25H16.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Z']],
  FileCode1: ['file-code-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.915,17.086.587A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.915ZM8.155,14.725A1.855,1.855,0,0,1,9.2,16.365v1.171c0,.283.264.465.673.465h.6a.75.75,0,0,1,0,1.5h-.6A2.032,2.032,0,0,1,7.7,17.536V16.365c0-.116-.116-.25-.3-.342L6.022,15.13a.749.749,0,0,1,0-1.259l1.319-.854c.245-.13.361-.264.361-.38V11.465A2.032,2.032,0,0,1,9.875,9.5h.6a.75.75,0,0,1,0,1.5h-.6c-.409,0-.673.182-.673.464v1.172A1.9,1.9,0,0,1,8.09,14.315s-.167.079-.167.184C7.923,14.663,8.155,14.725,8.155,14.725Zm10.785.429-1.507.854c-.312.143-.424.289-.424.357v1.171A2.127,2.127,0,0,1,14.631,19.5h-.686a.75.75,0,1,1,0-1.5h.686c.5,0,.878-.2.878-.465V16.365a1.9,1.9,0,0,1,1.248-1.695s.16-.09.16-.2-.223-.175-.223-.175a1.861,1.861,0,0,1-1.185-1.663V11.465c0-.264-.377-.464-.878-.464h-.686a.75.75,0,0,1,0-1.5h.686a2.127,2.127,0,0,1,2.378,1.964v1.172c0,.068.112.214.361.325l1.57.886a.75.75,0,0,1,0,1.306Z']],
  FileCodeAdd: ['file-code-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.082A.246.246,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM9,18.251H7.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H4a.75.75,0,0,1,0-1.5H5.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H9a.75.75,0,0,1,0,1.5Z']],
  FileCode2: ['file-code-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.915,17.086.587A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.915ZM10.573,14.592l-2.5,2.5a1,1,0,0,1-1.414-1.414l1.616-1.616a.25.25,0,0,0,0-.354L6.659,12.093a1,1,0,0,1,1.414-1.415l2.5,2.5A1,1,0,0,1,10.573,14.592ZM16.5,14H13a1,1,0,0,1,0-2h3.5a1,1,0,0,1,0,2Z']],
  FileCodeCash: ['file-code-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.082A.246.246,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM7.538,21.178c-.094.023-.288.109-.288.293v.28a.75.75,0,0,1-1.5,0V21.5a.248.248,0,0,0-.248-.247H5a.75.75,0,0,1,0-1.5H7.033a.592.592,0,0,0,.22-1.141L5.19,17.785a2.085,2.085,0,0,1,.344-3.978.334.334,0,0,0,.216-.328v-.228a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25H8a.75.75,0,0,1,0,1.5H5.967a.592.592,0,0,0-.22,1.141l2.063.825a2.084,2.084,0,0,1-.272,3.961Z']],
  Xml: ['xml', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.059,14.722a.624.624,0,0,1-.28.838.615.615,0,0,1-.279.066.627.627,0,0,1-.559-.346s-.812-1.623-.847-1.695a.112.112,0,0,0-.184-.007l-.851,1.7a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.305-2.609a.252.252,0,0,0,0-.224L4.941,9.28a.625.625,0,0,1,1.118-.558s.791,1.591.854,1.709.129.09.169.009l.859-1.718a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224ZM14.125,15a.625.625,0,0,1-1.25,0V12.066c0-.142-.169-.079-.207-.005l-.109.219a.65.65,0,0,1-1.118,0s-.08-.154-.117-.235-.2-.086-.2.014V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s.76,1.533.818,1.635a.148.148,0,0,0,.25-.008l.814-1.627A.625.625,0,0,1,14.125,9Zm4.375.625h-2A1.627,1.627,0,0,1,14.875,14V9a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  Xml1: ['xml-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM8.559,19.222a.625.625,0,1,1-1.118.558L6.224,17.345a.25.25,0,0,0-.448,0L4.559,19.78A.625.625,0,0,1,4,20.126a.625.625,0,0,1-.559-.9l1.805-3.609a.252.252,0,0,0,0-.224L3.441,11.78a.625.625,0,1,1,1.118-.558l1.217,2.435a.251.251,0,0,0,.448,0l1.217-2.435a.625.625,0,1,1,1.118.558l-1.8,3.609a.252.252,0,0,0,0,.224Zm6.066.279a.625.625,0,1,1-1.25,0V14.946c0-.306-.292-.215-.381-.036l-.435.87a.625.625,0,0,1-1.118,0s-.33-.685-.436-.873-.38-.2-.38,0V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,1.184-.279l1.217,2.434a.25.25,0,0,0,.448,0l1.217-2.434a.625.625,0,0,1,1.184.279ZM20,20.126H17.5A2.127,2.127,0,0,1,15.375,18V11.5a.625.625,0,1,1,1.25,0V18a.877.877,0,0,0,.875.875H20a.625.625,0,0,1,0,1.25Z']],
  Ym: ['ym', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,4.5H2A1.5,1.5,0,0,0,.5,6V18A1.5,1.5,0,0,0,2,19.5H22A1.5,1.5,0,0,0,23.5,18V6A1.5,1.5,0,0,0,22,4.5ZM11.625,10A2.621,2.621,0,0,1,9.8,12.492a.247.247,0,0,0-.176.233V15a.625.625,0,0,1-1.25,0V12.725a.247.247,0,0,0-.176-.233A2.621,2.621,0,0,1,6.375,10V9a.625.625,0,1,1,1.25,0v1a1.375,1.375,0,0,0,2.75,0V9a.625.625,0,1,1,1.25,0Zm5,5a.625.625,0,0,1-1.25,0V12.025c0-.136-.148-.081-.188,0l-.128.256a.65.65,0,0,1-1.118,0s-.1-.187-.136-.271-.18-.066-.18.01V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s.747,1.484.794,1.587a.182.182,0,0,0,.3-.006l.791-1.581A.625.625,0,0,1,16.625,9Z']],
  Ym1: ['ym-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM11.125,13.428A2.62,2.62,0,0,1,9.3,15.919a.247.247,0,0,0-.176.233v3.276a.625.625,0,0,1-1.25,0V16.152a.247.247,0,0,0-.176-.233,2.62,2.62,0,0,1-1.824-2.491v-2a.625.625,0,0,1,1.25,0v2a1.375,1.375,0,0,0,2.75,0v-2a.625.625,0,0,1,1.25,0Zm6,6a.625.625,0,0,1-1.25,0V14.719c0-.181-.237-.17-.313-.017l-.5,1.005a.625.625,0,0,1-1.118,0l-.524-1.047c-.08-.161-.292-.123-.292.019v4.749a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,1.184-.279l1.217,2.435a.251.251,0,0,0,.448,0l1.217-2.435a.625.625,0,0,1,1.184.279Z']],
  FileCode1Alternate: ['file-code-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.707,5.708,16.293.294A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.415A1,1,0,0,0,21.707,5.708ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.147l4.535,4.535A.5.5,0,0,1,20,7.036Z', 'M8.952,11.137V9.965c0-.169.265-.214.423-.214h.6a1,1,0,1,0,0-2h-.6A2.275,2.275,0,0,0,6.952,9.965l0,1.027a.245.245,0,0,1-.107.2c-.354.239-1.462.965-1.462.965a1,1,0,0,0,0,1.678l1.455.952A.249.249,0,0,1,6.952,15v1.036a2.275,2.275,0,0,0,2.423,2.214h.6a1,1,0,1,0,0-2h-.6c-.158,0-.423-.045-.423-.214V14.865a2.077,2.077,0,0,0-.881-1.673.243.243,0,0,1,0-.382A2.077,2.077,0,0,0,8.952,11.137Z', 'M18.564,12.131s-1.671-.922-1.711-.943a.238.238,0,0,1-.1-.163V9.965a2.366,2.366,0,0,0-2.627-2.214h-.686a1,1,0,1,0,0,2h.686c.439,0,.627.163.627.214v1.172a2.027,2.027,0,0,0,.933,1.671.241.241,0,0,1,0,.392,2.022,2.022,0,0,0-.936,1.665v1.172c0,.052-.188.214-.627.214h-.686a1,1,0,0,0,0,2h.686a2.366,2.366,0,0,0,2.627-2.214l-.01-1.018c0-.064.022-.1.107-.155s1.709-.993,1.709-.993a1,1,0,0,0,0-1.74Z']],
  FileCode2Alternate: ['file-code-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.706,5.708,16.292.294A1,1,0,0,0,15.585,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.415A1,1,0,0,0,21.706,5.708ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.964a.5.5,0,0,1,.354.147l4.535,4.535A.5.5,0,0,1,20,7.036Z', 'M8.073,10.178a1,1,0,0,0-1.415,1.414l1.616,1.616a.25.25,0,0,1,0,.354L6.658,15.177a1,1,0,0,0,1.415,1.415l2.5-2.5a1,1,0,0,0,0-1.414Z', 'M16.5,11.5H13a1,1,0,0,0,0,2h3.5a1,1,0,0,0,0-2Z']],
  Bin1: ['bin-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.875,13.5A1.377,1.377,0,0,0,5.5,12.126H4.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H5.5A1.377,1.377,0,0,0,6.875,13.5Z', 'M22.478,0H1.522A1.524,1.524,0,0,0,0,1.523V22.478A1.524,1.524,0,0,0,1.522,24H22.478A1.524,1.524,0,0,0,24,22.478V1.523A1.524,1.524,0,0,0,22.478,0ZM8.09,17.929a2.72,2.72,0,0,1-2.725,2.2H3.5a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625H5.365a2.72,2.72,0,0,1,2.725,2.2,2.588,2.588,0,0,1-.72,2.252.246.246,0,0,0,0,.352A2.587,2.587,0,0,1,8.09,17.929Zm5.41.947a.625.625,0,1,1,0,1.25h-4a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25v-6.25a.25.25,0,0,0-.25-.25H9.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25H12.375a.25.25,0,0,0-.25.25v6.25a.25.25,0,0,0,.25.25Zm6.625.625a.625.625,0,0,1-.481.608.644.644,0,0,1-.144.017.627.627,0,0,1-.559-.346L16.6,15.1a.25.25,0,0,0-.474.112V19.5a.625.625,0,1,1-1.25,0v-8a.625.625,0,0,1,1.184-.279L18.4,15.906a.25.25,0,0,0,.474-.111V11.5a.625.625,0,1,1,1.25,0Z', 'M4.125,18.626a.25.25,0,0,0,.25.25H5.5a1.375,1.375,0,0,0,0-2.75H4.375a.25.25,0,0,0-.25.25Z']],
  App: ['app', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12a.875.875,0,0,0,0-1.75Z', 'M7,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.876.876,0,0,0,7,9.626Z', 'M17,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,10.5Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,.625-.625H12a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,11.875,12.626Zm5,0h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,12.626Z']],
  App1: ['app-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,12.126H10.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H11.5a1.375,1.375,0,0,0,0-2.75Z', 'M5.5,12.126A1.377,1.377,0,0,0,4.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,5.5,12.126Z', 'M22.478,0H1.522A1.524,1.524,0,0,0,0,1.523V22.478A1.524,1.524,0,0,0,1.522,24H22.478A1.524,1.524,0,0,0,24,22.478V1.523A1.524,1.524,0,0,0,22.478,0ZM8.125,19.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-5.9a2.7,2.7,0,0,1,2.1-2.678A2.629,2.629,0,0,1,8.125,13.5ZM11.4,16.126H10.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,11.4,16.126Zm6,0H16.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,17.4,16.126Z', 'M17.5,12.126H16.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H17.5a1.375,1.375,0,0,0,0-2.75Z']],
  Apk: ['apk', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.875.875,0,0,0,7,9.626Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,10.5Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,.625-.625H12a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,11.875,12.626Zm4.686-.448,2.382,2.381a.625.625,0,0,1-.885.884s-1.662-1.657-1.74-1.74-.193-.053-.193.041V15a.625.625,0,0,1-1.25,0V9a.625.625,0,1,1,1.25,0V10.27c0,.164.153.069.153.069l1.78-1.78a.625.625,0,1,1,.885.884l-2.382,2.381A.25.25,0,0,0,16.561,12.178Z', 'M12,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12a.875.875,0,0,0,0-1.75Z']],
  Apk1: ['apk-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,12.126H10.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H11.5a1.375,1.375,0,0,0,0-2.75Z', 'M22.489,0H1.511A1.513,1.513,0,0,0,0,1.512V22.49A1.513,1.513,0,0,0,1.511,24H22.489A1.513,1.513,0,0,0,24,22.49V1.512A1.513,1.513,0,0,0,22.489,0ZM8.125,19.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-5.9a2.7,2.7,0,0,1,2.1-2.678A2.629,2.629,0,0,1,8.125,13.5ZM11.4,16.126H10.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,11.4,16.126Zm8.546,2.933a.625.625,0,0,1-.884.884L16.39,17.276s-.265-.134-.265.116V19.5a.625.625,0,1,1-1.25,0v-8a.625.625,0,1,1,1.25,0v2.141c0,.249.238.112.238.112l2.7-2.695a.625.625,0,0,1,.884.884l-3.381,3.381a.25.25,0,0,0,0,.354Z', 'M5.5,12.126A1.377,1.377,0,0,0,4.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,5.5,12.126Z']],
  Asp: ['asp', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z', 'M7,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.876.876,0,0,0,7,9.626Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,10.5Zm2.3-4.133,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,11.8,8.376h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Zm5.448,1.758h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,12.626Z']],
  Bin: ['bin', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,12.626H6.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7a.875.875,0,0,0,0-1.75Z', 'M7,9.626H6.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7a.875.875,0,0,0,0-1.75Z', 'M22.478,4.5H1.522A1.524,1.524,0,0,0,0,6.023V17.978A1.524,1.524,0,0,0,1.522,19.5H22.478A1.524,1.524,0,0,0,24,17.978V6.023A1.524,1.524,0,0,0,22.478,4.5ZM8.649,12.162a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H5.5A.625.625,0,0,1,4.875,15V9A.625.625,0,0,1,5.5,8.376H6.924a2.174,2.174,0,0,1,2.137,1.6,2.128,2.128,0,0,1-.412,1.866A.25.25,0,0,0,8.649,12.162Zm3.726,2.214H12.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.125a.25.25,0,0,0,.25-.25V9.876a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.125a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,12.375,14.376Zm5.75.625a.625.625,0,0,1-.481.608.644.644,0,0,1-.144.017.627.627,0,0,1-.559-.346s-1.631-3.245-1.667-3.334-.149-.067-.149,0V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s1.583,3.187,1.645,3.29.171.094.171-.007V9a.625.625,0,1,1,1.25,0Z']],
  FileApp: ['file-app', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,13.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12a.875.875,0,0,0,0-1.75Z', 'M7,13.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14.5A.876.876,0,0,0,7,13.626Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.125,19a.625.625,0,0,1-1.25,0V16.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V14.626a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,14.5Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13a.625.625,0,0,1,.625-.625H12a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,11.875,16.626Zm5,0h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,1,1-1.25,0V13a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,16.626Z', 'M17,13.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z']],
  FileApp1: ['file-app-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M15,12.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H15a.875.875,0,0,0,0-1.75Z', 'M5,12.126A.876.876,0,0,0,4.125,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.876.876,0,0,0,5,12.126Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.125,17.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.126a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,7.125,13Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H10a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,9.875,15.126Zm5,0h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H15a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,14.875,15.126Z', 'M10,12.126H9.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H10a.875.875,0,0,0,0-1.75Z']],
  FileCode: ['file-code', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.915,17.086.587A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.915ZM10.864,18.96l-.019.018a.75.75,0,0,1-1.06-.036L6.452,15.371a.752.752,0,0,1,0-1.025l3.333-3.571.018-.019A.75.75,0,0,1,10.881,11.8L8.186,14.687a.249.249,0,0,0,0,.341l2.7,2.89A.751.751,0,0,1,10.864,18.96Zm6.684-3.59-3.333,3.571-.018.019a.75.75,0,0,1-1.078-1.043l2.7-2.888a.249.249,0,0,0,0-.341l-2.7-2.889a.751.751,0,0,1,1.1-1.025l3.333,3.571A.752.752,0,0,1,17.548,15.37Z']],
  FileBin: ['file-bin', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.5,16.626H6.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7.5a.875.875,0,0,0,0-1.75Z', 'M7.5,13.626H6.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7.5a.875.875,0,0,0,0-1.75Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7Zm-12.6,9.161a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H6A.625.625,0,0,1,5.375,19V13A.625.625,0,0,1,6,12.376H7.424a2.174,2.174,0,0,1,2.137,1.6,2.13,2.13,0,0,1-.412,1.867A.25.25,0,0,0,9.149,16.162Zm3.726,2.214H13a.625.625,0,1,1,0,1.25H11a.625.625,0,0,1,0-1.25h.125a.25.25,0,0,0,.25-.25v-4.25a.25.25,0,0,0-.25-.25H11a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.125a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,12.875,18.376Zm5.75.625a.625.625,0,0,1-.481.608.644.644,0,0,1-.144.017.627.627,0,0,1-.559-.346s-1.631-3.245-1.667-3.335-.149-.066-.149,0V19a.625.625,0,1,1-1.25,0V13a.625.625,0,0,1,1.184-.279s1.583,3.187,1.645,3.29.171.095.171-.007V13a.625.625,0,1,1,1.25,0Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FileCPlusPlus: ['file-c-plus-plus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM7.5,18.376a.625.625,0,0,1,0,1.25,3.625,3.625,0,1,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,1,0,0,4.75Zm6-1.75H12.375a.25.25,0,0,0-.25.25V18a.625.625,0,0,1-1.25,0V16.876a.25.25,0,0,0-.25-.25H9.5a.625.625,0,1,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V14a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H13.5a.625.625,0,1,1,0,1.25Zm6,0H18.375a.25.25,0,0,0-.25.25V18a.625.625,0,1,1-1.25,0V16.876a.25.25,0,0,0-.25-.25H15.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V14a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H19.5a.625.625,0,0,1,0,1.25Z']],
  FileCodeCheck1: ['file-code-check-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm3.273,5.205-2.9,3.874a1.49,1.49,0,0,1-1.1.6c-.035,0-.071,0-.106,0a1.5,1.5,0,0,1-1.061-.441l-1.5-1.5a.75.75,0,1,1,1.061-1.06l1.3,1.3a.25.25,0,0,0,.377-.027l2.732-3.643a.75.75,0,1,1,1.2.9Z']],
  FileCodeClock: ['file-code-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.082A.246.246,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.2,8.2,0,0,1,1.009,1.007c.042.051.126.125.126.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.75,10.5a6.75,6.75,0,1,0,6.75,6.75A6.758,6.758,0,0,0,6.75,10.5Zm0,11.5a4.75,4.75,0,1,1,4.75-4.75A4.756,4.756,0,0,1,6.75,22Z', 'M8.75,16.251H8A.25.25,0,0,1,7.75,16v-1.25a1,1,0,1,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z']],
  FileCodeDownload1: ['file-code-download-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.391,7.312-2,2.5a.517.517,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,4.5,17.5h.876A.125.125,0,0,0,5.5,17.38V14.5a1,1,0,1,1,2,0v2.875a.127.127,0,0,0,.124.125H8.5a.5.5,0,0,1,.391.812Z', 'M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z']],
  FileCodeCheck: ['file-code-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm3.273,5.205-2.9,3.874a1.49,1.49,0,0,1-1.1.6c-.035,0-.071,0-.106,0a1.5,1.5,0,0,1-1.061-.441l-1.5-1.5a.75.75,0,1,1,1.061-1.06l1.3,1.3a.25.25,0,0,0,.377-.027l2.732-3.643a.75.75,0,1,1,1.2.9Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.082A.246.246,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z']],
  FileCodeDownload: ['file-code-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.391,7.312-2,2.5a.517.517,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,4.5,17.5h.876A.125.125,0,0,0,5.5,17.38V14.5a1,1,0,1,1,2,0v2.875a.127.127,0,0,0,.124.125H8.5a.5.5,0,0,1,.391.812Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z']],
  FileCodeDisable: ['file-code-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.5,6.5,0,0,0,6.5,11ZM2.533,19.6a4.448,4.448,0,0,1-.367-3.319,4.5,4.5,0,0,1,3.112-3.117,4.444,4.444,0,0,1,3.325.367.252.252,0,0,1,.052.4L2.931,19.655A.252.252,0,0,1,2.533,19.6Zm8.3-.887a4.5,4.5,0,0,1-3.112,3.116A4.443,4.443,0,0,1,4.4,21.467a.252.252,0,0,1-.052-.4l5.724-5.722a.252.252,0,0,1,.4.051A4.448,4.448,0,0,1,10.834,18.717Z']],
  FileCodeEdit: ['file-code-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M15.5,14.5V12a1.252,1.252,0,0,0-1.25-1.25h-1.5A1.252,1.252,0,0,0,11.5,12v2.5a1.251,1.251,0,0,0,1.25,1.25h1.5A1.251,1.251,0,0,0,15.5,14.5ZM14,14a.249.249,0,0,1-.25.25h-.5A.249.249,0,0,1,13,14V12.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M14,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.5,8V5.5a1.252,1.252,0,0,0-1.25-1.25h-1.5A1.252,1.252,0,0,0,16.5,5.5V8a1.251,1.251,0,0,0,1.25,1.25h1.5A1.251,1.251,0,0,0,20.5,8ZM19,7.5a.249.249,0,0,1-.25.25h-.5A.249.249,0,0,1,18,7.5V6a.25.25,0,0,1,.25-.25h.5A.25.25,0,0,1,19,6Z', 'M23.664,3,21.25.587A2,2,0,0,0,19.835,0H8.25a2,2,0,0,0-2,2v9.57a.247.247,0,0,0,.073.176l1.5,1.5a.25.25,0,0,0,.427-.176V2.5a.5.5,0,0,1,.5-.5H19.629a.5.5,0,0,1,.353.147L22.1,4.269a.5.5,0,0,1,.146.354V18a.5.5,0,0,1-.5.5H13.427a.247.247,0,0,0-.234.334c.162.437.359,1.153.447,1.485a.243.243,0,0,0,.24.18h8.37a2,2,0,0,0,2-2V4.416A2,2,0,0,0,23.664,3Z', 'M10.9,18.445l-6.58-6.58a2.71,2.71,0,0,0-3.606-.273,2.622,2.622,0,0,0-.2,3.881l6.679,6.679a.249.249,0,0,0,.353,0L10.9,18.8A.252.252,0,0,0,10.9,18.445Z', 'M11.688,20.132,8.879,22.94a.25.25,0,0,0,.128.422l3.143.629a.55.55,0,0,0,.1.009.5.5,0,0,0,.49-.6L12.11,20.26A.25.25,0,0,0,11.688,20.132Z']],
  FileCodeHeart1: ['file-code-heart-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.715,6.451a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.284a.749.749,0,0,0,0,1.023l2.667,2.857a.749.749,0,0,0,1.06.036l.019-.017a.753.753,0,0,0,.018-1.043l-2.03-2.174a.249.249,0,0,1,0-.341Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.019,2.667-2.857a.749.749,0,0,0,0-1.023L17.382,5.427a.749.749,0,0,0-1.06-.036.731.731,0,0,0-.037,1.06l2.03,2.174a.249.249,0,0,1,0,.341Z', 'M23.415,3,21,.587A2,2,0,0,0,19.587,0H8A2,2,0,0,0,6,2v9.535a.224.224,0,0,0,.122.213c.073.04.146.079.217.122a.633.633,0,0,0,.377-.043A5.019,5.019,0,0,1,7.833,11.3.243.243,0,0,0,8,11.071V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.354.146l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.97a.251.251,0,0,0-.207.111c-.238.334-.845,1.027-1.244,1.474a.249.249,0,0,0,.189.414H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.415,3Z', 'M12.629,14.45A3.508,3.508,0,0,0,9.584,12.5a3.665,3.665,0,0,0-2.695,1.126l-.212.212a.25.25,0,0,1-.353,0l-.212-.212A3.665,3.665,0,0,0,3.417,12.5a3.528,3.528,0,0,0-2.391,6.012l5.113,5.334a.5.5,0,0,0,.723,0l5.106-5.327A3.524,3.524,0,0,0,12.629,14.45Z']],
  FileCodeHome: ['file-code-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.869a.25.25,0,0,0,.33.232,2.479,2.479,0,0,1,1.34,0A.25.25,0,0,0,8,9.869V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H16.162a.25.25,0,0,0-.241.216,2.026,2.026,0,0,1-.866,1.33.248.248,0,0,0,.14.454H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.25,12A1.25,1.25,0,0,0,14,10.751H12.5A1.25,1.25,0,0,0,11.25,12v.7a.25.25,0,0,0,.088.191s1.2,1.014,1.256,1.062.156-.051.156-.134V12.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V14a.25.25,0,0,1-.25.25h-.318c-.088,0-.076.141,0,.2L14.4,15.488a.273.273,0,0,0,.294.037A1.234,1.234,0,0,0,15.25,14.5Z', 'M7.324,12.119a.5.5,0,0,0-.647,0l-6.5,5.5A.5.5,0,0,0,.5,18.5H1.75a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H5a.5.5,0,0,0,.5-.5v-2.25a1.5,1.5,0,0,1,3,0V23.5A.5.5,0,0,0,9,24h2.5a.5.5,0,0,0,.5-.5v-4.75a.25.25,0,0,1,.25-.25H13.5a.5.5,0,0,0,.324-.882Z']],
  FileCodeHeart: ['file-code-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.751,11.5V15a.75.75,0,1,0,1.5,0V11.5a.75.75,0,0,0-1.5,0Z', 'M13.751,8.5V5a.75.75,0,1,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.251,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5a1.25,1.25,0,0,0-1.25,1.25V8a1.251,1.251,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.251,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.249.249,0,0,1-.25-.25V6a.249.249,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.415,3,21,.586A2,2,0,0,0,19.587,0H8A2,2,0,0,0,6,2v9.572a.177.177,0,0,0,.089.158c.089.049.179.1.267.15a.413.413,0,0,0,.261.012A5.01,5.01,0,0,1,7.833,11.3.243.243,0,0,0,8,11.071V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.354.146l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.97a.251.251,0,0,0-.207.111c-.238.334-.845,1.027-1.244,1.474a.249.249,0,0,0,.189.414H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.415,3Z', 'M12.629,14.45A3.508,3.508,0,0,0,9.584,12.5a3.661,3.661,0,0,0-2.695,1.126l-.212.212a.25.25,0,0,1-.353,0l-.212-.212A3.661,3.661,0,0,0,3.417,12.5a3.528,3.528,0,0,0-2.391,6.012l5.113,5.334a.5.5,0,0,0,.723,0l5.106-5.327A3.524,3.524,0,0,0,12.629,14.45Z']],
  FileDatabase: ['file-database', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.915,17.086.587A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.915ZM16.75,18.484c0,.623-2,1.767-5.264,1.767-3.379,0-5.221-1.14-5.221-1.726v-1.46a.244.244,0,0,1,.356-.219,11.744,11.744,0,0,0,4.865.938,11.7,11.7,0,0,0,4.906-.978.244.244,0,0,1,.358.218Zm0-3.967c0,.623-2,1.767-5.264,1.767-3.379,0-5.221-1.141-5.221-1.727V12.984a.243.243,0,0,1,.356-.219,11.744,11.744,0,0,0,4.865.938,11.7,11.7,0,0,0,4.906-.978.244.244,0,0,1,.358.219ZM11.486,12.2c-3.379,0-5.221-1.141-5.221-1.727s1.842-1.725,5.221-1.725c3.407,0,5.264,1.114,5.264,1.686C16.75,11.06,14.752,12.2,11.486,12.2Z']],
  FileCodeLock: ['file-code-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M11.25,12v2.5a1.252,1.252,0,0,0,1.25,1.25H14a1.252,1.252,0,0,0,1.25-1.25V12A1.251,1.251,0,0,0,14,10.751H12.5A1.251,1.251,0,0,0,11.25,12Zm1.5.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V14a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.684a.245.245,0,0,0,.184.235,4.438,4.438,0,0,1,1.429.687A.247.247,0,0,0,8,10.4V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H11.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M8.611,15.513a.123.123,0,0,1-.111-.12V14.251a3.5,3.5,0,1,0-7,0v1.134a.114.114,0,0,1-.113.128A1.5,1.5,0,0,0,0,17v5.5A1.5,1.5,0,0,0,1.5,24h7A1.5,1.5,0,0,0,10,22.5V17A1.5,1.5,0,0,0,8.611,15.513ZM5,21.251a1,1,0,1,1,1-1A1,1,0,0,1,5,21.251Zm1.5-5.866a.12.12,0,0,1-.106.116l-2.782,0a.122.122,0,0,1-.112-.116V14.251a1.5,1.5,0,1,1,3,0Z']],
  FileCodeInformation: ['file-code-information', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM6,13.25a1,1,0,1,1-1,1A1,1,0,0,1,6,13.25Zm2,8.5H5a.75.75,0,0,1,0-1.5h.627a.123.123,0,0,0,.123-.123V17.876a.125.125,0,0,0-.125-.125H5a.75.75,0,0,1,0-1.5H6A1.251,1.251,0,0,1,7.25,17.5v2.623a.127.127,0,0,0,.126.127H8a.75.75,0,0,1,0,1.5Z']],
  FileCodeInformation1: ['file-code-information-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM6,13.25a1,1,0,1,1-1,1A1,1,0,0,1,6,13.25Zm2,8.5H5a.75.75,0,0,1,0-1.5h.627a.123.123,0,0,0,.123-.123V17.876a.125.125,0,0,0-.125-.125H5a.75.75,0,0,1,0-1.5H6A1.251,1.251,0,0,1,7.25,17.5v2.623a.127.127,0,0,0,.126.127H8a.75.75,0,0,1,0,1.5Z']],
  FileCodeRefresh: ['file-code-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.875,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.875,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.375,8V5.5a1.251,1.251,0,0,0-1.25-1.25h-1.5a1.251,1.251,0,0,0-1.25,1.25V8a1.252,1.252,0,0,0,1.25,1.25h1.5A1.252,1.252,0,0,0,20.375,8Zm-1.5-.5a.25.25,0,0,1-.25.25h-.5a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.539,3,21.125.587A2,2,0,0,0,19.71,0H8.125a2,2,0,0,0-2,2V9.8a.245.245,0,0,0,.23.249c.348.021,1.014.071,1.486.144a.247.247,0,0,0,.284-.247V2.5a.5.5,0,0,1,.5-.5H19.5a.5.5,0,0,1,.353.146l2.122,2.121a.5.5,0,0,1,.146.354V18a.5.5,0,0,1-.5.5h-7.4a.242.242,0,0,0-.238.205,7.185,7.185,0,0,1-.409,1.454.244.244,0,0,0,.225.34h8.318a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.539,3Z', 'M12.8,11.56a.5.5,0,0,0-.545.109l-1.3,1.3a.245.245,0,0,1-.343,0,6.312,6.312,0,0,0-4.078-1.716,6.465,6.465,0,0,0-6.652,6.29A6.375,6.375,0,0,0,11.232,21.6,1,1,0,1,0,9.67,20.354a4.376,4.376,0,1,1-3.42-7.1,4.34,4.34,0,0,1,2.925,1.122.257.257,0,0,1,0,.367L7.793,16.126a.5.5,0,0,0,.354.853H12.6a.5.5,0,0,0,.5-.5V12.022A.5.5,0,0,0,12.8,11.56Z']],
  FilePhp: ['file-php', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM6.875,16.626h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13a.625.625,0,0,1,.625-.625H7a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,6.875,16.626ZM14.125,19a.625.625,0,1,1-1.25,0V16.876a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13a.625.625,0,1,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13a.625.625,0,1,1,1.25,0Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,1,1-1.25,0V13a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,16.626Z', 'M17,13.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z', 'M7,13.626H6.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7a.875.875,0,0,0,0-1.75Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FileCodeRemove: ['file-code-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.082A.246.246,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.2,8.2,0,0,1,1.009,1.007c.042.051.126.125.126.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm1.237,6.677,1.414,1.414a.75.75,0,0,1-1.06,1.06L6.677,18.738a.252.252,0,0,0-.354,0L4.909,20.153a.75.75,0,0,1-1.061-1.061l1.414-1.414a.25.25,0,0,0,0-.354L3.849,15.91a.75.75,0,1,1,1.06-1.061l1.414,1.414a.25.25,0,0,0,.354,0l1.414-1.414A.75.75,0,0,1,9.152,15.91L7.737,17.324A.252.252,0,0,0,7.737,17.678Z']],
  FileCodeSearch: ['file-code-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.168,19.788a.241.241,0,0,1-.03-.3A5.515,5.515,0,1,0,8.45,21.172a.241.241,0,0,1,.3.03l2.506,2.506a1,1,0,0,0,1.414-1.414ZM5.5,20.034a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,5.5,20.034Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2v7.3a.243.243,0,0,0,.222.241,6.864,6.864,0,0,1,1.453.309A.243.243,0,0,0,8,9.625V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H12.382a.241.241,0,0,0-.23.169,6.9,6.9,0,0,1-.426,1.026.245.245,0,0,0,.066.268l.394.393a.448.448,0,0,0,.328.143H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M11.25,12v.446a.231.231,0,0,0,.041.132,6.971,6.971,0,0,1,1.14,2.95.24.24,0,0,0,.236.214L14,15.751a1.252,1.252,0,0,0,1.25-1.25V12A1.25,1.25,0,0,0,14,10.751H12.5A1.25,1.25,0,0,0,11.25,12Zm1.5.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V14a.25.25,0,0,1-.25.25H13a.25.25,0,0,1-.25-.25Z']],
  FileCodeShield: ['file-code-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.267a.248.248,0,0,0,.244.25c.368.005,1.045.021,1.5.048A.247.247,0,0,0,8,9.315V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.49a.242.242,0,0,0-.235.184,8.179,8.179,0,0,1-.53,1.459.245.245,0,0,0,.218.356H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M12.072,12.041A16.381,16.381,0,0,0,6.479,11a15.983,15.983,0,0,0-5.551,1.04A1.545,1.545,0,0,0,0,13.457v3.392a7.716,7.716,0,0,0,5.19,6.806A9,9,0,0,0,6.479,24a9.023,9.023,0,0,0,1.288-.346C10.848,22.481,13,19.682,13,16.849V13.457A1.545,1.545,0,0,0,12.072,12.041ZM9.5,17.251h-2a.25.25,0,0,0-.25.25v2a.75.75,0,0,1-1.5,0v-2a.25.25,0,0,0-.25-.25h-2a.75.75,0,1,1,0-1.5h2a.25.25,0,0,0,.25-.25v-2a.75.75,0,1,1,1.5,0v2a.25.25,0,0,0,.25.25h2a.75.75,0,1,1,0,1.5Z']],
  FileCodeShare1: ['file-code-share-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.286,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.856a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V11.62a.248.248,0,0,0,.469.114,3.6,3.6,0,0,1,1.4-1.51A.244.244,0,0,0,8,10.014V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.981a.246.246,0,0,0-.211.379,4.245,4.245,0,0,1,.616,1.425.246.246,0,0,0,.238.2H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.387,12.345a1.879,1.879,0,0,0,.31-.163.749.749,0,0,0,.018-1.042L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.751.751,0,0,0,0,1.024l.228.245a1.994,1.994,0,0,0,.224.122A4.242,4.242,0,0,1,14.2,12.23C14.218,12.281,14.339,12.365,14.387,12.345Z', 'M8.442,16a.245.245,0,0,1,.266.012,2.74,2.74,0,0,0,4.167-1.425A2.758,2.758,0,0,0,10.25,11a2.807,2.807,0,0,0-2.713,3.058.245.245,0,0,1-.115.222L4.558,16a.245.245,0,0,1-.266-.012,2.707,2.707,0,0,0-2.406-.349A2.706,2.706,0,0,0,.124,17.414,2.759,2.759,0,0,0,2.75,21a2.729,2.729,0,0,0,1.887-.761.246.246,0,0,1,.259-.054s1.924.782,2.464,1a.237.237,0,0,1,.144.214,2.753,2.753,0,1,0,5.361-1.025,2.681,2.681,0,0,0-1.736-1.74,2.74,2.74,0,0,0-2.767.623.242.242,0,0,1-.258.053L5.553,18.3a.114.114,0,0,1-.06-.084l-.03-.353a.118.118,0,0,1,.056-.1Z']],
  FileCodeShield1: ['file-code-shield-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.286,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.856a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.267a.248.248,0,0,0,.244.25c.368.005,1.045.021,1.5.048A.247.247,0,0,0,8,9.315V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.49a.242.242,0,0,0-.235.184,8.179,8.179,0,0,1-.53,1.459.245.245,0,0,0,.218.356H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.471,12.312a2.039,2.039,0,0,0,.226-.13.749.749,0,0,0,.018-1.042L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.284a.749.749,0,0,0,0,1.023l.88.944a2.688,2.688,0,0,0,.841.416,3.031,3.031,0,0,1,1.571,1.588A.24.24,0,0,0,14.471,12.312Z', 'M12.072,12.041A16.381,16.381,0,0,0,6.479,11a15.983,15.983,0,0,0-5.551,1.04A1.545,1.545,0,0,0,0,13.457v3.392a7.716,7.716,0,0,0,5.19,6.806A9,9,0,0,0,6.479,24a9.023,9.023,0,0,0,1.288-.346C10.848,22.481,13,19.682,13,16.849V13.457A1.545,1.545,0,0,0,12.072,12.041ZM9.5,17.251h-2a.25.25,0,0,0-.25.25v2a.75.75,0,0,1-1.5,0v-2a.25.25,0,0,0-.25-.25h-2a.75.75,0,1,1,0-1.5h2a.25.25,0,0,0,.25-.25v-2a.75.75,0,1,1,1.5,0v2a.25.25,0,0,0,.25.25h2a.75.75,0,1,1,0,1.5Z']],
  FileCodeStar: ['file-code-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.607,17.139a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,11.738,15h-2.5a.249.249,0,0,1-.229-.151L7.664,11.732,7.651,11.7a1.293,1.293,0,0,0-2.317.028L3.988,14.849a.251.251,0,0,1-.23.15h-2.5a1.23,1.23,0,0,0-1.166.76,1.272,1.272,0,0,0,.32,1.4L2.6,19.111a.25.25,0,0,1,.063.286L1.444,22.211a1.253,1.253,0,0,0,.314,1.451,1.359,1.359,0,0,0,1.506.167l3.112-1.753a.249.249,0,0,1,.245,0l3.113,1.753a1.277,1.277,0,0,0,1.506-.167,1.254,1.254,0,0,0,.315-1.45L10.331,19.4a.252.252,0,0,1,.063-.287Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V8.793a.248.248,0,0,0,.232.249,8.446,8.446,0,0,1,1.452.211A.248.248,0,0,0,8,9.013V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.165a.231.231,0,0,0-.163.06c-.218.2-.918.829-1.2,1.087a.222.222,0,0,0-.067.243l.205.473a.263.263,0,0,0,.259.136H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M11.25,12v.763a.247.247,0,0,0,.232.249c.259.016.684.047.987.09a.248.248,0,0,0,.281-.248V12.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V13.58a.242.242,0,0,0,.079.178,6.6,6.6,0,0,1,.955,1.414c.056.108.18.126.216.078a1.242,1.242,0,0,0,.25-.749V12A1.25,1.25,0,0,0,14,10.751H12.5A1.25,1.25,0,0,0,11.25,12Z']],
  FileCodeShare: ['file-code-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2v9.563a.25.25,0,0,0,.474.11,3.466,3.466,0,0,1,1.394-1.451A.245.245,0,0,0,8,10.01V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.981a.246.246,0,0,0-.211.379,4.245,4.245,0,0,1,.616,1.425.246.246,0,0,0,.238.2H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M8.442,16a.245.245,0,0,1,.266.012,2.74,2.74,0,0,0,4.167-1.425A2.758,2.758,0,0,0,10.25,11a2.807,2.807,0,0,0-2.713,3.058.245.245,0,0,1-.115.222L4.558,16a.245.245,0,0,1-.266-.012,2.707,2.707,0,0,0-2.406-.349A2.706,2.706,0,0,0,.124,17.414,2.759,2.759,0,0,0,2.75,21a2.729,2.729,0,0,0,1.887-.761.246.246,0,0,1,.259-.054s1.924.782,2.464,1a.237.237,0,0,1,.144.214,2.753,2.753,0,1,0,5.361-1.025,2.681,2.681,0,0,0-1.736-1.74,2.74,2.74,0,0,0-2.767.623.242.242,0,0,1-.258.053L5.553,18.3a.114.114,0,0,1-.06-.084l-.03-.353a.118.118,0,0,1,.056-.1Z']],
  FileCodeSync1: ['file-code-sync-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.322,12.2a.751.751,0,0,0,1.042-.018l.017-.019,2.667-2.856a.751.751,0,0,0,0-1.024L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06L18.474,8.8,16.286,11.14A.751.751,0,0,0,16.322,12.2Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.278a.247.247,0,0,0,.241.249c.364.009,1.037.041,1.485.092A.246.246,0,0,0,8,9.371V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.584,12.261c.055-.036.109-.075.113-.079a.749.749,0,0,0,.018-1.042L12.526,8.8l2.188-2.344a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l.866.928a.243.243,0,0,0,.237.067,1.949,1.949,0,0,1,1.213.086A1.992,1.992,0,0,1,14.5,12.235S14.553,12.281,14.584,12.261Z', 'M11.77,18.6a1,1,0,0,0-1.256.583,4.034,4.034,0,0,1-1.278,1.93,4.162,4.162,0,0,1-5.656-.472.254.254,0,0,1,.014-.348L5.31,18.577a.5.5,0,0,0-.353-.853H.5a.5.5,0,0,0-.5.5v4.457a.5.5,0,0,0,.854.353l.974-.975a.244.244,0,0,1,.353.009,6.085,6.085,0,0,0,10.211-2.2A1,1,0,0,0,11.77,18.6Z', 'M12.691,11.773a.5.5,0,0,0-.545.109l-1.03,1.03a.244.244,0,0,1-.352-.007A6.1,6.1,0,0,0,.567,15.13a1,1,0,0,0,1.88.683A4.02,4.02,0,0,1,3.718,13.9a4.157,4.157,0,0,1,5.638.435.256.256,0,0,1-.012.351L7.69,16.339a.5.5,0,0,0,.353.853H12.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,12.691,11.773Z']],
  Rb1: ['rb-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.125,18.626a.25.25,0,0,0,.25.25H15.5a1.375,1.375,0,1,0,0-2.75H14.375a.25.25,0,0,0-.25.25Z', 'M10.875,13.5A1.377,1.377,0,0,0,9.5,12.126H8.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H9.5A1.377,1.377,0,0,0,10.875,13.5Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM11.942,19.059a.625.625,0,0,1,0,.884.643.643,0,0,1-.884,0L8.552,17.437a.25.25,0,0,0-.427.177V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625H9.4a2.7,2.7,0,0,1,2.678,2.1A2.629,2.629,0,0,1,9.5,16.126H9.3c-.118,0-.149.13-.06.229C9.3,16.421,11.942,19.059,11.942,19.059Zm6.148-1.13a2.72,2.72,0,0,1-2.725,2.2H13.5a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625h1.865a2.72,2.72,0,0,1,2.725,2.2,2.588,2.588,0,0,1-.72,2.252.246.246,0,0,0,0,.352A2.587,2.587,0,0,1,18.09,17.929Z', 'M16.875,13.5A1.377,1.377,0,0,0,15.5,12.126H14.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H15.5A1.377,1.377,0,0,0,16.875,13.5Z']],
  FileCodeSubtract: ['file-code-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,10.97a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,6.5,10.97ZM9,18.22H4a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Z', 'M17.75,11.532v3.5a.75.75,0,0,0,1.5,0v-3.5a.75.75,0,0,0-1.5,0Z', 'M13.75,8.532v-3.5a.75.75,0,0,0-1.5,0v3.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8.032v-2.5A1.252,1.252,0,0,0,19,4.282H17.5a1.252,1.252,0,0,0-1.25,1.25v2.5a1.251,1.251,0,0,0,1.25,1.25H19A1.251,1.251,0,0,0,20.25,8.032Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25v-1.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3.032,21,.618A2,2,0,0,0,19.585.032H8a2,2,0,0,0-2,2V9.308a.247.247,0,0,0,.242.249c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.392V2.532a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.147L21.854,4.3A.5.5,0,0,1,22,4.653V18.032a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.446A2,2,0,0,0,23.414,3.032Z', 'M14.406,15.689a1.227,1.227,0,0,0,.844-1.157v-2.5A1.25,1.25,0,0,0,14,10.782H12.5a1.211,1.211,0,0,0-.914.429.192.192,0,0,0,.029.179A8.134,8.134,0,0,1,12.623,12.4c.043.051.127.124.127.018a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25v1.589a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.637,14.367,15.7,14.406,15.689Z']],
  FileCodeSync: ['file-code-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13,4.251a.75.75,0,0,0-.75.75V8.5a.75.75,0,0,0,1.5,0V5A.75.75,0,0,0,13,4.251Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.278a.247.247,0,0,0,.241.249c.364.009,1.037.041,1.485.092A.246.246,0,0,0,8,9.371V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M11.77,18.6a1,1,0,0,0-1.256.582,4.036,4.036,0,0,1-1.278,1.931,4.162,4.162,0,0,1-5.656-.472.254.254,0,0,1,.014-.348L5.31,18.577a.5.5,0,0,0-.353-.853H.5a.5.5,0,0,0-.5.5v4.457a.5.5,0,0,0,.854.353l.974-.975a.244.244,0,0,1,.353.009,6.085,6.085,0,0,0,10.211-2.2A1,1,0,0,0,11.77,18.6Z', 'M12.691,11.773a.5.5,0,0,0-.545.109l-1.03,1.03a.244.244,0,0,1-.352-.007A6.1,6.1,0,0,0,.567,15.13a1,1,0,0,0,1.88.683A4.02,4.02,0,0,1,3.718,13.9a4.157,4.157,0,0,1,5.638.435.256.256,0,0,1-.012.351L7.69,16.339a.5.5,0,0,0,.353.853H12.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,12.691,11.773Z']],
  FileCodeWarning: ['file-code-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.749,11.5V15a.75.75,0,1,0,1.5,0V11.5a.75.75,0,0,0-1.5,0Z', 'M11.249,12v2.5a1.252,1.252,0,0,0,1.25,1.25H14a1.251,1.251,0,0,0,1.25-1.25V12A1.25,1.25,0,0,0,14,10.751H12.5A1.251,1.251,0,0,0,11.249,12Zm1.5.25h1v2h-1Z', 'M13.749,8.5V5a.75.75,0,1,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.249,8V5.5A1.25,1.25,0,0,0,19,4.251H17.5a1.251,1.251,0,0,0-1.25,1.25V8a1.252,1.252,0,0,0,1.25,1.25H19A1.251,1.251,0,0,0,20.249,8Zm-1.5-.5a.249.249,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.249.249,0,0,1,.25.25Z', 'M23.414,3,21,.586A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.82a.248.248,0,0,0,.234.249,7.354,7.354,0,0,1,1.443.216A.249.249,0,0,0,8,10.047V2.5A.5.5,0,0,1,8.5,2H19.378a.5.5,0,0,1,.354.146l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.156a.25.25,0,0,0-.221.366l.787,1.5a.25.25,0,0,0,.221.134H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M7.78,12.272a1.449,1.449,0,0,0-2.561,0L.164,21.906a1.426,1.426,0,0,0,.047,1.408A1.454,1.454,0,0,0,1.444,24H11.555a1.456,1.456,0,0,0,1.233-.686,1.428,1.428,0,0,0,.047-1.409ZM5.749,16a.75.75,0,0,1,1.5,0v2.5a.75.75,0,0,1-1.5,0Zm.75,6.25a1,1,0,1,1,1-1A1,1,0,0,1,6.5,22.251Z']],
  FileCodeUpload1: ['file-code-upload-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.45,6.217a.5.5,0,0,1-.45.283H7.624a.125.125,0,0,0-.124.121V20.5a1,1,0,0,1-2,0V17.626a.126.126,0,0,0-.124-.125H4.5a.5.5,0,0,1-.391-.813l2-2.5a.519.519,0,0,1,.782,0l2,2.5A.5.5,0,0,1,8.95,17.218Z', 'M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z']],
  FileCss: ['file-css', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM8.42,18.989a.625.625,0,0,1,0,1.25,3.625,3.625,0,1,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,1,0,0,4.75Zm2.927-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532h-1.7a.625.625,0,1,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25h-1.7a.678.678,0,0,0-.376,1.242Zm5,0,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532h-1.7a.625.625,0,1,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25h-1.7a.678.678,0,0,0-.376,1.242Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FileCsv: ['file-csv', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM8.5,18.876a.625.625,0,0,1,0,1.25,3.625,3.625,0,1,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,1,0,0,4.75Zm2.927-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Zm7.7-.367A8.178,8.178,0,0,1,17.5,19.876a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,14.875,15V13.5a.625.625,0,1,1,1.25,0V15a6.91,6.91,0,0,0,.7,3.014.227.227,0,0,0,.357-.006,6.916,6.916,0,0,0,.7-3.008V13.5a.625.625,0,1,1,1.25,0Z']],
  FileDat: ['file-dat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.956,13.82a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,7.375,16,2.237,2.237,0,0,0,5.956,13.82Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M11.5,13.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14.5A.876.876,0,0,0,11.5,13.626Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM5,19.626A.625.625,0,0,1,4.375,19V13A.625.625,0,0,1,5,12.376a3.625,3.625,0,0,1,0,7.25ZM13.625,19a.625.625,0,1,1-1.25,0V16.876a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V14.626a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,13.625,14.5ZM19,13.626H17.875a.25.25,0,0,0-.25.25V19a.625.625,0,1,1-1.25,0V13.876a.25.25,0,0,0-.25-.25H15a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Z']],
  FileExe: ['file-exe', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM6.375,15.376H7.5a.625.625,0,1,1,0,1.25H6.375a.25.25,0,0,0-.25.25V18a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,4.875,18V14A1.625,1.625,0,0,1,6.5,12.376h2a.625.625,0,0,1,0,1.25h-2A.375.375,0,0,0,6.125,14v1.125A.25.25,0,0,0,6.375,15.376Zm7.684,3.346a.625.625,0,1,1-1.118.558l-.854-1.709a.1.1,0,0,0-.176,0l-.852,1.706a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,0,1,1.118-.558s.806,1.616.84,1.681a.122.122,0,0,0,.2.006l.843-1.687a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm2.316-3.346H17.5a.625.625,0,0,1,0,1.25H16.375a.25.25,0,0,0-.25.25V18a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,14.875,18V14A1.625,1.625,0,0,1,16.5,12.376h2a.625.625,0,0,1,0,1.25h-2a.375.375,0,0,0-.375.375v1.125A.25.25,0,0,0,16.375,15.376Z']],
  Sql: ['sql', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9.626a.876.876,0,0,0-.875.875V13a.875.875,0,0,0,1.75,0V10.5A.876.876,0,0,0,12,9.626Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.427,10.868l1.84,1.226A1.928,1.928,0,0,1,7.2,15.626H5.5a.625.625,0,1,1,0-1.25H7.2a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,6.8,8.376H8.5a.625.625,0,0,1,0,1.25H6.8a.678.678,0,0,0-.376,1.242ZM14.125,13a2.114,2.114,0,0,1-.974,1.774.1.1,0,0,0,.01.159l.727.577a.634.634,0,0,1,.1.878.626.626,0,0,1-.878.1l-1.93-1.53A2.126,2.126,0,0,1,9.875,13V10.5a2.125,2.125,0,1,1,4.25,0ZM18.5,15.626h-2A1.627,1.627,0,0,1,14.875,14V9a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  FileExe1: ['file-exe-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM4.375,13.876H5.5a.625.625,0,0,1,0,1.25H4.375a.25.25,0,0,0-.25.25V16.5a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,2.875,16.5v-4A1.625,1.625,0,0,1,4.5,10.876h2a.625.625,0,0,1,0,1.25h-2a.375.375,0,0,0-.375.375v1.125A.25.25,0,0,0,4.375,13.876Zm7.684,3.346a.625.625,0,1,1-1.118.558l-.854-1.709a.094.094,0,0,0-.175,0L9.059,17.78a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.305-2.609a.252.252,0,0,0,0-.224L7.941,11.78a.625.625,0,1,1,1.118-.558s.806,1.616.84,1.681a.122.122,0,0,0,.2.006l.843-1.687a.625.625,0,1,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm2.316-3.346H15.5a.625.625,0,0,1,0,1.25H14.375a.25.25,0,0,0-.25.25V16.5a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,12.875,16.5v-4A1.625,1.625,0,0,1,14.5,10.876h2a.625.625,0,0,1,0,1.25h-2a.375.375,0,0,0-.375.375v1.125A.25.25,0,0,0,14.375,13.876Z']],
  FileHtml1: ['file-html-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H1.2A1.114,1.114,0,0,0,0,10v9a1.114,1.114,0,0,0,1.2,1H21.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708ZM6.125,17.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H3.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V11.5a.625.625,0,1,1,1.25,0ZM11.5,12.126H10.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V12.376a.25.25,0,0,0-.25-.25H7.5a.625.625,0,1,1,0-1.25h4a.625.625,0,0,1,0,1.25ZM17.125,17.5a.625.625,0,1,1-1.25,0V14.454c0-.141-.12-.067-.16.013l-.156.313a.65.65,0,0,1-1.118,0s-.1-.211-.15-.3-.166-.086-.166,0V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.72,1.436.783,1.566a.182.182,0,0,0,.32-.009l.779-1.557a.625.625,0,0,1,1.184.279Zm4.375.625h-2A1.627,1.627,0,0,1,17.875,16.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  FileHtml: ['file-html', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.5,6h3.9a.25.25,0,0,0,.177-.427L14.427.428A.25.25,0,0,0,14,.6V4.5A1.5,1.5,0,0,0,15.5,6Z', 'M22.8,10H3.25A.25.25,0,0,1,3,9.751V9a.25.25,0,0,1,.25-.25h16.5A.25.25,0,0,0,20,8.5V7.251A.25.25,0,0,0,19.75,7H15.5A2.5,2.5,0,0,1,13,4.5V.251A.25.25,0,0,0,12.75,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H18a1.99,1.99,0,0,0,1.936-1.537c.017-.07-.019-.213-.128-.213H3.25A.25.25,0,0,1,3,22v-.75A.25.25,0,0,1,3.25,21H22.8A1.114,1.114,0,0,0,24,20V11A1.114,1.114,0,0,0,22.8,10ZM6.625,18.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H3.875a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V12.5a.625.625,0,1,1,1.25,0ZM12,13.126H10.875a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V13.376a.25.25,0,0,0-.25-.25H8a.625.625,0,1,1,0-1.25h4a.625.625,0,0,1,0,1.25ZM17.625,18.5a.625.625,0,1,1-1.25,0V15.566c0-.13-.155-.108-.206-.007l-.11.221a.65.65,0,0,1-1.118,0s-.07-.144-.117-.235-.2-.073-.2.009V18.5a.625.625,0,1,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.781,1.558.826,1.651a.133.133,0,0,0,.229,0l.827-1.653a.625.625,0,0,1,1.184.279ZM22,19.126H20A1.627,1.627,0,0,1,18.375,17.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  FileJava1: ['file-java-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.5,12.126A.876.876,0,0,0,6.625,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.876.876,0,0,0,7.5,12.126Z', 'M17.5,12.126a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.876.876,0,0,0,17.5,12.126Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM4.625,16a2.125,2.125,0,0,1-4.25,0,.625.625,0,0,1,1.25,0,.875.875,0,0,0,1.75,0V11.5a.625.625,0,0,1,1.25,0Zm5,1.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H6.875a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.625,13Zm5-4.5A8.178,8.178,0,0,1,13,17.876a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,10.375,13V11.5a.625.625,0,1,1,1.25,0V13a6.908,6.908,0,0,0,.718,3.054.2.2,0,0,0,.315,0A6.912,6.912,0,0,0,13.375,13V11.5a.625.625,0,1,1,1.25,0Zm3.75,4.5V15.376a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V17.5a.625.625,0,1,1-1.25,0V13.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,19.625,13v4.5a.625.625,0,1,1-1.25,0Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileJs: ['file-js', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM11.125,17a2.125,2.125,0,0,1-4.25,0,.625.625,0,0,1,1.25,0,.875.875,0,0,0,1.75,0V12.5a.625.625,0,1,1,1.25,0Zm2.3-2.633,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H12.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H13.8a.678.678,0,0,0-.376,1.242Z']],
  FileJs1: ['file-js-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM9.125,16a2.125,2.125,0,0,1-4.25,0,.625.625,0,1,1,1.25,0,.875.875,0,0,0,1.75,0V11.5a.625.625,0,1,1,1.25,0Zm2.3-2.633,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FilePy: ['file-py', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,13.626H8.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H9a.875.875,0,0,0,0-1.75Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM8.875,16.626h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13a.625.625,0,0,1,.625-.625H9a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,8.875,16.626ZM17.125,14A2.621,2.621,0,0,1,15.3,16.492a.247.247,0,0,0-.176.233V19a.625.625,0,1,1-1.25,0V16.725a.247.247,0,0,0-.177-.233A2.622,2.622,0,0,1,11.875,14V13a.625.625,0,1,1,1.25,0v1a1.375,1.375,0,0,0,2.75,0V13a.625.625,0,1,1,1.25,0Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FileRb: ['file-rb', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,13.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H14.5a.875.875,0,0,0,0-1.75Z', 'M14.5,16.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H14.5a.875.875,0,0,0,0-1.75Z', 'M10.375,14a.876.876,0,0,0-.875-.875H8.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H9.5A.877.877,0,0,0,10.375,14Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM11.442,18.943a.669.669,0,0,1-.884,0L9.052,17.437a.25.25,0,0,0-.427.177V18.5a.625.625,0,0,1-1.25,0v-6A.625.625,0,0,1,8,11.876H9.375a2.21,2.21,0,0,1,2.238,1.9,2.127,2.127,0,0,1-1.628,2.293.246.246,0,0,0-.119.414l1.576,1.576A.625.625,0,0,1,11.442,18.943Zm4.707-3.281a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H13a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,13,11.876h1.424a2.174,2.174,0,0,1,2.137,1.6,2.13,2.13,0,0,1-.412,1.867A.25.25,0,0,0,16.149,15.662Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FilePl: ['file-pl', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M9.5,13.626H8.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H9.5a.875.875,0,0,0,0-1.75Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.375,16.626h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13A.625.625,0,0,1,8,12.376H9.5a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,9.375,16.626Zm6.625,3H14A1.627,1.627,0,0,1,12.375,18V13a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  FilePl1: ['file-pl-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,12.126H7.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H8a.875.875,0,0,0,0-1.75Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.875,15.126h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H8a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,7.875,15.126Zm6.625,3h-2A1.627,1.627,0,0,1,10.875,16.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,1,1,0,1.25Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileRb1: ['file-rb-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.375,13a.876.876,0,0,0-.875-.875H6.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7.5A.877.877,0,0,0,8.375,13Z', 'M12.5,12.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12.5a.875.875,0,0,0,0-1.75Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM9.442,17.943a.625.625,0,0,1-.884,0L7.052,16.437a.25.25,0,0,0-.427.177V17.5a.625.625,0,0,1-1.25,0v-6A.625.625,0,0,1,6,10.876H7.375a2.21,2.21,0,0,1,2.238,1.9,2.127,2.127,0,0,1-1.628,2.293.246.246,0,0,0-.119.414l1.576,1.576A.625.625,0,0,1,9.442,17.943Zm4.707-3.281a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H11a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,11,10.876h1.424a2.174,2.174,0,0,1,2.137,1.6,2.13,2.13,0,0,1-.412,1.867A.25.25,0,0,0,14.149,14.662Z', 'M12.5,15.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12.5a.875.875,0,1,0,0-1.75Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileYm: ['file-ym', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7Zm-9.625,6.5A2.621,2.621,0,0,1,10.3,15.992a.247.247,0,0,0-.176.233V18.5a.625.625,0,0,1-1.25,0V16.225a.247.247,0,0,0-.177-.233A2.622,2.622,0,0,1,6.875,13.5v-1a.625.625,0,1,1,1.25,0v1a1.375,1.375,0,0,0,2.75,0v-1a.625.625,0,1,1,1.25,0Zm5,5a.625.625,0,1,1-1.25,0V15.525c0-.136-.148-.081-.188,0l-.128.256a.65.65,0,0,1-1.118,0s-.1-.187-.136-.271-.18-.066-.18.01V18.5a.625.625,0,1,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.747,1.484.794,1.587a.182.182,0,0,0,.3-.006l.791-1.581a.625.625,0,0,1,1.184.279Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z']],
  FileSql1: ['file-sql-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,11.626a.876.876,0,0,0-.875.875V15a.875.875,0,0,0,1.75,0V12.5A.876.876,0,0,0,10,11.626Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM4.427,12.868l1.84,1.226A1.928,1.928,0,0,1,5.2,17.626H3.5a.625.625,0,0,1,0-1.25H5.2a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,4.8,10.376H6.5a.625.625,0,0,1,0,1.25H4.8a.678.678,0,0,0-.376,1.242ZM12.125,15a2.107,2.107,0,0,1-.836,1.677c-.078.059-.211.182-.083.292l.682.541a.634.634,0,0,1,.1.878.626.626,0,0,1-.878.1l-1.93-1.53A2.126,2.126,0,0,1,7.875,15V12.5a2.125,2.125,0,1,1,4.25,0ZM16.5,17.626h-2A1.627,1.627,0,0,1,12.875,16V11a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileXml: ['file-xml', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.059,19.222a.625.625,0,1,1-1.118.558s-.812-1.623-.847-1.7a.112.112,0,0,0-.184-.008l-.851,1.7a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.305-2.609a.252.252,0,0,0,0-.224L4.941,13.78a.625.625,0,1,1,1.118-.558s.791,1.591.854,1.709.128.091.169.009l.859-1.718a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm5.066.279a.625.625,0,1,1-1.25,0V16.566c0-.142-.17-.079-.207,0l-.109.219a.65.65,0,0,1-1.118,0s-.08-.154-.117-.235-.2-.086-.2.014V19.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.76,1.533.818,1.635a.148.148,0,0,0,.25-.007l.814-1.628a.625.625,0,0,1,1.184.279Zm4.375.625h-2A1.627,1.627,0,0,1,14.875,18.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  Html1: ['html-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM6.625,19.5a.625.625,0,0,1-1.25,0V17.376a.25.25,0,0,0-.25-.25H3.875a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,1,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13.5a.625.625,0,1,1,1.25,0ZM12,14.126H10.875a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V14.376a.25.25,0,0,0-.25-.25H8a.625.625,0,1,1,0-1.25h4a.625.625,0,0,1,0,1.25ZM17.625,19.5a.625.625,0,1,1-1.25,0V16.454c0-.142-.12-.067-.16.013l-.156.313a.65.65,0,0,1-1.118,0s-.1-.211-.15-.3-.166-.086-.166,0V19.5a.625.625,0,1,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.72,1.436.783,1.566a.183.183,0,0,0,.32-.009l.779-1.557a.625.625,0,0,1,1.184.279ZM22,20.126H20A1.627,1.627,0,0,1,18.375,18.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  Iso: ['iso', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,9.626a.876.876,0,0,0-.875.875v3a.875.875,0,0,0,1.75,0v-3A.876.876,0,0,0,16,9.626Z', 'M22.478,4.5H1.522A1.524,1.524,0,0,0,0,6.023V17.978A1.524,1.524,0,0,0,1.522,19.5H22.478A1.524,1.524,0,0,0,24,17.978V6.023A1.524,1.524,0,0,0,22.478,4.5Zm-15.1,9.875H7.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,1,1,0-1.25h.125a.25.25,0,0,0,.25-.25V9.876a.25.25,0,0,0-.25-.25H5.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25H7.375a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,7.375,14.376Zm3.052-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H9.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,10.8,8.376h1.7a.625.625,0,0,1,0,1.25H10.8a.678.678,0,0,0-.376,1.242Zm7.7,2.633a2.125,2.125,0,0,1-4.25,0v-3a2.125,2.125,0,1,1,4.25,0Z']],
  Java: ['java', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.876.876,0,0,0,19,9.626Z', 'M9,9.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.876.876,0,0,0,9,9.626Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-16.375,9a2.125,2.125,0,0,1-4.25,0,.625.625,0,1,1,1.25,0,.875.875,0,0,0,1.75,0V9a.625.625,0,0,1,1.25,0Zm5,1.5a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H8.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,11.125,10.5Zm5-4.5A8.178,8.178,0,0,1,14.5,15.376a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,11.875,10.5V9a.625.625,0,1,1,1.25,0v1.5a6.931,6.931,0,0,0,.771,3.161.138.138,0,0,0,.213-.01,6.926,6.926,0,0,0,.766-3.151V9a.625.625,0,1,1,1.25,0Zm5,4.5a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.626a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,21.125,10.5Z']],
  Hqx: ['hqx', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9.626a.876.876,0,0,0-.875.875V13a.875.875,0,0,0,1.75,0V10.5A.876.876,0,0,0,12,9.626Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V9a.625.625,0,1,1,1.25,0Zm5-2a2.112,2.112,0,0,1-.993,1.786c-.029.019-.044.088.029.147l.727.577a.634.634,0,0,1,.1.879.627.627,0,0,1-.878.1l-1.93-1.53A2.126,2.126,0,0,1,9.875,13V10.5a2.125,2.125,0,1,1,4.25,0Zm4.934,1.721a.625.625,0,1,1-1.118.558s-.752-1.5-.814-1.629-.194-.12-.242-.023-.826,1.652-.826,1.652a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.778,1.564.833,1.667a.122.122,0,0,0,.22-.008l.829-1.659a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Z']],
  Html: ['html', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H3.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V9a.625.625,0,0,1,1.25,0ZM11.5,9.626H10.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9.876a.25.25,0,0,0-.25-.25H7.5a.625.625,0,1,1,0-1.25h4a.625.625,0,0,1,0,1.25ZM17.125,15a.625.625,0,0,1-1.25,0V11.954c0-.142-.12-.067-.16.013l-.156.313a.65.65,0,0,1-1.118,0s-.1-.211-.15-.3-.166-.086-.166,0V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s.72,1.436.783,1.566a.183.183,0,0,0,.32-.009l.779-1.557A.625.625,0,0,1,17.125,9Zm4.375.625h-2A1.627,1.627,0,0,1,17.875,14V9a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  Iso1: ['iso-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,12.126A1.377,1.377,0,0,0,16.125,13.5v4a1.375,1.375,0,1,0,2.75,0v-4A1.377,1.377,0,0,0,17.5,12.126Z', 'M22.478,0H1.522A1.524,1.524,0,0,0,0,1.523V22.478A1.524,1.524,0,0,0,1.522,24H22.478A1.524,1.524,0,0,0,24,22.478V1.523A1.524,1.524,0,0,0,22.478,0ZM7.5,18.876a.625.625,0,0,1,0,1.25h-4a.625.625,0,0,1,0-1.25H4.625a.25.25,0,0,0,.25-.25v-6.25a.25.25,0,0,0-.25-.25H3.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25H6.375a.25.25,0,0,0-.25.25v6.25a.25.25,0,0,0,.25.25Zm3.305-4.422,1.949.975a2.479,2.479,0,0,1-1.108,4.7H9.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.548-2.329l-1.949-.974a2.48,2.48,0,0,1,1.109-4.7H13.5a.625.625,0,0,1,0,1.25H11.354a1.229,1.229,0,0,0-.549,2.328Zm9.32,3.047a2.625,2.625,0,1,1-5.25,0v-4a2.625,2.625,0,1,1,5.25,0Z']],
  Js1: ['js-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM11.125,17.5a2.625,2.625,0,0,1-5.25,0,.625.625,0,0,1,1.25,0,1.375,1.375,0,0,0,2.75,0v-6a.625.625,0,1,1,1.25,0Zm2.68-3.047,1.949.975a2.479,2.479,0,0,1-1.108,4.7H12.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.549-2.329l-1.95-.974a2.48,2.48,0,0,1,1.109-4.7H16.5a.625.625,0,0,1,0,1.25H14.354a1.229,1.229,0,0,0-.549,2.328Z']],
  Php1: ['php-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,12.126H5.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H6.5a1.375,1.375,0,0,0,0-2.75Z', 'M18.5,12.126H17.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H18.5a1.375,1.375,0,0,0,0-2.75Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM6.4,16.126H5.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,6.4,16.126ZM15.125,19.5a.625.625,0,1,1-1.25,0V16.376a.25.25,0,0,0-.25-.25h-2.25a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,1,1,1.25,0v3.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V11.5a.625.625,0,1,1,1.25,0ZM18.4,16.126H17.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,18.4,16.126Z']],
  Pl: ['pl', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,9.626H9.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H10a.875.875,0,0,0,0-1.75Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.875,12.626h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9A.625.625,0,0,1,8.5,8.376H10a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,9.875,12.626Zm6.625,3h-2A1.627,1.627,0,0,1,12.875,14V9a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  Pl1: ['pl-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.4,16.126H8.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,9.4,16.126Zm8.1,4H15A2.127,2.127,0,0,1,12.875,18V11.5a.625.625,0,1,1,1.25,0V18a.877.877,0,0,0,.875.875h2.5a.625.625,0,0,1,0,1.25Z', 'M9.5,12.126H8.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H9.5a1.375,1.375,0,0,0,0-2.75Z']],
  Py: ['py', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.855,12.626h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,1,1-1.25,0V9a.625.625,0,0,1,.625-.625h1.5a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,9.855,12.626ZM18.105,10a2.622,2.622,0,0,1-1.823,2.491.247.247,0,0,0-.177.233V15a.625.625,0,1,1-1.25,0V12.725a.247.247,0,0,0-.176-.233A2.621,2.621,0,0,1,12.855,10V9a.625.625,0,0,1,1.25,0v1a1.375,1.375,0,1,0,2.75,0V9a.625.625,0,0,1,1.25,0Z', 'M9.98,9.626H9.355a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H9.98a.875.875,0,0,0,0-1.75Z']],
  Py1: ['py-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,12.126H8.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H9.5a1.375,1.375,0,0,0,0-2.75Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.4,16.126H8.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,9.4,16.126ZM18.125,13.5A2.621,2.621,0,0,1,16.3,15.992a.247.247,0,0,0-.176.233V19.5a.625.625,0,1,1-1.25,0V16.225a.247.247,0,0,0-.176-.233A2.621,2.621,0,0,1,12.875,13.5v-2a.625.625,0,1,1,1.25,0v2a1.375,1.375,0,0,0,2.75,0v-2a.625.625,0,1,1,1.25,0Z']],
  Rb: ['rb', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14,12.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H14a.875.875,0,0,0,0-1.75Z', 'M9.875,10.5A.876.876,0,0,0,9,9.626H8.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H9A.877.877,0,0,0,9.875,10.5Z', 'M14,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H14a.875.875,0,0,0,0-1.75Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM10.942,15.443a.669.669,0,0,1-.884,0L8.552,13.937a.25.25,0,0,0-.427.177V15a.625.625,0,0,1-1.25,0V9A.625.625,0,0,1,7.5,8.376H8.875a2.21,2.21,0,0,1,2.238,1.9,2.127,2.127,0,0,1-1.628,2.293.246.246,0,0,0-.119.414l1.576,1.576A.625.625,0,0,1,10.942,15.443Zm4.707-3.281a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H12.5A.625.625,0,0,1,11.875,15V9a.625.625,0,0,1,.625-.625h1.424a2.174,2.174,0,0,1,2.137,1.6,2.128,2.128,0,0,1-.412,1.866A.25.25,0,0,0,15.649,12.162Z']],
  Js: ['js', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-11.375,9a2.125,2.125,0,0,1-4.25,0,.625.625,0,1,1,1.25,0,.875.875,0,0,0,1.75,0V9a.625.625,0,1,1,1.25,0Zm2.3-2.633,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H12.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,13.8,8.376h1.7a.625.625,0,0,1,0,1.25H13.8a.678.678,0,0,0-.376,1.242Z']],
  Php: ['php', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.875,12.626h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9A.625.625,0,0,1,5.5,8.376H7a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,6.875,12.626ZM14.125,15a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,1,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V9a.625.625,0,1,1,1.25,0Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,12.626Z', 'M17,9.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z', 'M7,9.626H6.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7a.875.875,0,0,0,0-1.75Z']],
  Sql1: ['sql-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.475,12.1A1.377,1.377,0,0,0,11.1,13.476v3.5a1.375,1.375,0,0,0,2.75,0v-3.5A1.377,1.377,0,0,0,12.475,12.1Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM5.8,14.442l1.95.975a2.479,2.479,0,0,1-1.108,4.7H4.5a.625.625,0,0,1,0-1.25H6.646A1.229,1.229,0,0,0,7.2,16.535l-1.95-.975a2.48,2.48,0,0,1,1.109-4.7H8.5a.625.625,0,0,1,0,1.25H6.354a1.23,1.23,0,0,0-.55,2.329Zm9.3,2.534a2.607,2.607,0,0,1-1.176,2.173.167.167,0,0,0,.011.283l.857.505a.625.625,0,1,1-.635,1.077S11.1,19.2,11.078,19.19A2.62,2.62,0,0,1,9.85,16.976v-3.5a2.625,2.625,0,0,1,5.25,0ZM20.475,20.1h-2.5a2.127,2.127,0,0,1-2.125-2.125v-6.5a.625.625,0,1,1,1.25,0v6.5a.876.876,0,0,0,.875.875h2.5a.625.625,0,0,1,0,1.25Z']],
  FileDatabaseAlternate: ['file-database-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.706,5.708,16.292.294A1,1,0,0,0,15.585,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.415A1,1,0,0,0,21.706,5.708ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.964a.5.5,0,0,1,.354.147l4.535,4.535A.5.5,0,0,1,20,7.036Z', 'M11.986,8.251c-3.379,0-5.222,1.14-5.222,1.726S8.607,11.7,11.986,11.7c3.265,0,5.263-1.143,5.263-1.765C17.249,9.365,15.392,8.251,11.986,8.251Z', 'M16.891,16.306a11.687,11.687,0,0,1-4.9.978,11.741,11.741,0,0,1-4.865-.938.245.245,0,0,0-.357.219v1.461c0,.585,1.843,1.725,5.222,1.725,3.265,0,5.263-1.144,5.263-1.767V16.525A.244.244,0,0,0,16.891,16.306Z', 'M16.891,12.225a11.687,11.687,0,0,1-4.9.978,11.741,11.741,0,0,1-4.865-.938.245.245,0,0,0-.357.219v1.574c0,.586,1.843,1.726,5.222,1.726,3.265,0,5.263-1.144,5.263-1.767V12.444A.245.245,0,0,0,16.891,12.225Z']],
  FileCPlusPlus1: ['file-c-plus-plus-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM5.5,16.876a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm6-1.75H10.375a.25.25,0,0,0-.25.25V16.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H7.5a.625.625,0,1,1,0-1.25H8.625a.25.25,0,0,0,.25-.25V12.5a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H11.5a.625.625,0,0,1,0,1.25Zm6,0H16.375a.25.25,0,0,0-.25.25V16.5a.625.625,0,1,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H13.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V12.5a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H17.5a.625.625,0,0,1,0,1.25Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileCodeClock1: ['file-code-clock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.244.244,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.75,10.5a6.75,6.75,0,1,0,6.75,6.75A6.758,6.758,0,0,0,6.75,10.5Zm0,11.5a4.75,4.75,0,1,1,4.75-4.75A4.756,4.756,0,0,1,6.75,22Z', 'M8.75,16.251H8A.25.25,0,0,1,7.75,16v-1.25a1,1,0,1,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z']],
  FileCodeEdit1: ['file-code-edit-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.388l.018-.017a.751.751,0,0,0,.018-1.043L12.686,9.154a.249.249,0,0,1,0-.341l2.028-2.174A.75.75,0,0,0,13.636,5.6l-.018.019L10.952,8.472a.749.749,0,0,0,0,1.023l2.666,2.857A.751.751,0,0,0,14.679,12.388Z', 'M16.286,11.328a.75.75,0,0,0,1.078,1.043l.017-.019L20.048,9.5a.752.752,0,0,0,0-1.025L17.382,5.615a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3.189,21,.775A2,2,0,0,0,19.585.189H8a2,2,0,0,0-2,2v8.694a.249.249,0,0,0,.073.177l1.5,1.5A.25.25,0,0,0,8,12.383V2.689a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.81V18.189a.5.5,0,0,1-.5.5H13.868a.247.247,0,0,0-.243.307c.106.422.27,1.155.346,1.5a.243.243,0,0,0,.243.191H22a2,2,0,0,0,2-2V4.6A2,2,0,0,0,23.414,3.189Z', 'M11.15,18.258l-6.58-6.58A2.71,2.71,0,0,0,.964,11.4a2.623,2.623,0,0,0-.2,3.882l6.679,6.679a.25.25,0,0,0,.353,0l3.354-3.354A.25.25,0,0,0,11.15,18.258Z', 'M11.938,19.944,9.129,22.753a.25.25,0,0,0,.128.422L12.4,23.8a.473.473,0,0,0,.1.01.5.5,0,0,0,.49-.6l-.628-3.143A.25.25,0,0,0,11.938,19.944Z']],
  FileCodeHome1: ['file-code-home-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.715,11.14,12.686,8.966a.249.249,0,0,1,0-.341L14.714,6.45a.75.75,0,0,0-1.078-1.042l-.017.018L10.952,8.284a.749.749,0,0,0,0,1.023l2.666,2.857a.751.751,0,0,0,1.061.036l.018-.018A.749.749,0,0,0,14.715,11.14Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.042l.018-.018,2.666-2.857a.751.751,0,0,0,0-1.024L17.382,5.426a.752.752,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.175a.25.25,0,0,1,0,.341Z', 'M23.415,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.869a.25.25,0,0,0,.331.232,2.485,2.485,0,0,1,1.339,0A.249.249,0,0,0,8,9.868V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.354.146l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H16.138a.249.249,0,0,0-.235.189,2.462,2.462,0,0,1-.948,1.363.247.247,0,0,0,.148.448H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.415,3Z', 'M7.323,12.119a.5.5,0,0,0-.646,0l-6.5,5.5A.5.5,0,0,0,.5,18.5H1.75a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H5a.5.5,0,0,0,.5-.5v-2.25a1.5,1.5,0,0,1,3,0V23.5A.5.5,0,0,0,9,24h2.5a.5.5,0,0,0,.5-.5v-4.75a.25.25,0,0,1,.25-.25H13.5a.5.5,0,0,0,.323-.882Z']],
  FileCodeQuestion: ['file-code-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,6.5,22.5Zm.939-4.173a.27.27,0,0,0-.189.273v.15a.75.75,0,0,1-1.5,0V18.2a1.257,1.257,0,0,1,.988-1.222,1.125,1.125,0,1,0-1.363-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,3.564,2.452Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z']],
  FileCodeRefresh1: ['file-code-refresh-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.411,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.856a.752.752,0,0,0,0-1.025L17.507,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.539,3,21.125.587A2,2,0,0,0,19.71,0H8.125a2,2,0,0,0-2,2V9.8a.245.245,0,0,0,.23.249c.348.021,1.014.071,1.486.144a.247.247,0,0,0,.284-.247V2.5a.5.5,0,0,1,.5-.5H19.5a.5.5,0,0,1,.353.146l2.122,2.121a.5.5,0,0,1,.146.354V18a.5.5,0,0,1-.5.5h-7.4a.242.242,0,0,0-.238.205,7.185,7.185,0,0,1-.409,1.454.244.244,0,0,0,.225.34h8.318a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.539,3Z', 'M14.6,12.046s-.036.3.1.219a1.122,1.122,0,0,0,.119-.083.749.749,0,0,0,.018-1.042L12.811,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L11.077,8.284a.749.749,0,0,0,0,1.023l.72.772a.245.245,0,0,0,.254.064,1.959,1.959,0,0,1,1.317.055A2,2,0,0,1,14.6,12.046Z', 'M12.8,11.56a.5.5,0,0,0-.545.109l-1.3,1.3a.245.245,0,0,1-.343,0,6.312,6.312,0,0,0-4.078-1.716,6.465,6.465,0,0,0-6.652,6.29A6.375,6.375,0,0,0,11.232,21.6,1,1,0,1,0,9.67,20.354a4.376,4.376,0,1,1-3.42-7.1,4.34,4.34,0,0,1,2.925,1.122.257.257,0,0,1,0,.367L7.793,16.126a.5.5,0,0,0,.354.853H12.6a.5.5,0,0,0,.5-.5V12.022A.5.5,0,0,0,12.8,11.56Z']],
  FileCodeUpload: ['file-code-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.45,6.217a.5.5,0,0,1-.45.283H7.624a.125.125,0,0,0-.124.121V20.5a1,1,0,0,1-2,0V17.626a.126.126,0,0,0-.124-.125H4.5a.5.5,0,0,1-.391-.813l2-2.5a.519.519,0,0,1,.782,0l2,2.5A.5.5,0,0,1,8.95,17.218Z', 'M17.75,11.5V15a.75.75,0,0,0,1.5,0V11.5a.75.75,0,1,0-1.5,0Z', 'M13.75,8.5V5a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,1.5,0Z', 'M20.25,8V5.5A1.251,1.251,0,0,0,19,4.251H17.5A1.251,1.251,0,0,0,16.25,5.5V8a1.252,1.252,0,0,0,1.25,1.25H19A1.252,1.252,0,0,0,20.25,8Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25V6a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.248.248,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.642a.245.245,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M14.406,15.658A1.227,1.227,0,0,0,15.25,14.5V12A1.25,1.25,0,0,0,14,10.751H12.5a1.208,1.208,0,0,0-.914.429.193.193,0,0,0,.029.179,8.126,8.126,0,0,1,1.008,1.007c.043.051.127.125.127.019a.111.111,0,0,1,.115-.134H13.5a.25.25,0,0,1,.25.25V14.09a.235.235,0,0,0,.021.1,7.983,7.983,0,0,1,.484,1.376C14.266,15.606,14.367,15.671,14.406,15.658Z']],
  FileCodeWarning1: ['file-code-warning-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.464,6.451a.75.75,0,0,0-1.079-1.043l-.017.019L10.7,8.284a.749.749,0,0,0,0,1.023l2.667,2.857a.749.749,0,0,0,1.06.036l.018-.017a.752.752,0,0,0,.019-1.043l-2.03-2.174a.249.249,0,0,1,0-.341Z', 'M16.035,11.14a.75.75,0,0,0,1.078,1.043l.018-.019L19.8,9.307a.749.749,0,0,0,0-1.023L17.131,5.427a.749.749,0,0,0-1.06-.036.731.731,0,0,0-.037,1.06l2.03,2.174a.251.251,0,0,1,0,.341Z', 'M23.164,3,20.749.587A2,2,0,0,0,19.335,0H7.749a2,2,0,0,0-2,2V9.9a.246.246,0,0,0,.276.247,7.782,7.782,0,0,1,1.448,0A.246.246,0,0,0,7.749,9.9V2.5a.5.5,0,0,1,.5-.5H19.128a.5.5,0,0,1,.354.146L21.6,4.268a.5.5,0,0,1,.146.354V18a.5.5,0,0,1-.5.5H13.406a.25.25,0,0,0-.221.366l.787,1.5a.25.25,0,0,0,.221.134h7.556a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.164,3Z', 'M8.03,12.272a1.449,1.449,0,0,0-2.561,0L.414,21.906a1.426,1.426,0,0,0,.047,1.408A1.454,1.454,0,0,0,1.694,24H11.805a1.456,1.456,0,0,0,1.233-.686,1.428,1.428,0,0,0,.047-1.409ZM6,16a.75.75,0,0,1,1.5,0v2.5a.75.75,0,0,1-1.5,0Zm.75,6.25a1,1,0,1,1,1-1A1,1,0,0,1,6.749,22.251Z']],
  FileHqx: ['file-hqx', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.5,13.626a.876.876,0,0,0-.875.875V17a.875.875,0,0,0,1.75,0V14.5A.876.876,0,0,0,12.5,13.626Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.625,19a.625.625,0,0,1-1.25,0V16.876a.25.25,0,0,0-.25-.25H6.875a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V13a.625.625,0,1,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13a.625.625,0,1,1,1.25,0Zm5-2a2.112,2.112,0,0,1-.993,1.786c-.029.019-.044.088.029.147l.727.577a.633.633,0,0,1,.1.879.627.627,0,0,1-.878.1l-1.93-1.53A2.126,2.126,0,0,1,10.375,17V14.5a2.125,2.125,0,1,1,4.25,0Zm4.934,1.721a.625.625,0,1,1-1.118.558s-.752-1.5-.814-1.629-.194-.12-.243-.023-.825,1.652-.825,1.652a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.778,1.564.833,1.666a.122.122,0,0,0,.22-.007l.829-1.659a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Z']],
  FileDmg: ['file-dmg', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M6.456,13.32a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,7.875,15.5,2.237,2.237,0,0,0,6.456,13.32Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM5.5,19.126a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm8.625-.625a.625.625,0,1,1-1.25,0V15.574c0-.154-.15-.134-.224.021l-.092.185a.65.65,0,0,1-1.118,0s-.047-.092-.107-.214-.209-.117-.209.008V18.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.72,1.429.786,1.571a.173.173,0,0,0,.311,0l.785-1.569a.625.625,0,0,1,1.184.279Zm5-4a.625.625,0,0,1-1.25,0V14a.875.875,0,1,0-1.75,0v3a.875.875,0,0,0,1.717.237c.011-.036.034-.112-.084-.112H17.5a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625V17a2.125,2.125,0,1,1-4.25,0V14a2.125,2.125,0,1,1,4.25,0Z']],
  FilePy1: ['file-py-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.5,12.126H6.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7.5a.875.875,0,0,0,0-1.75Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.375,15.126h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6A.625.625,0,0,1,6,10.876H7.5a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,7.375,15.126Zm8.25-2.625A2.621,2.621,0,0,1,13.8,14.992a.247.247,0,0,0-.176.233V17.5a.625.625,0,0,1-1.25,0V15.225a.247.247,0,0,0-.177-.233A2.622,2.622,0,0,1,10.375,12.5v-1a.625.625,0,1,1,1.25,0v1a1.375,1.375,0,0,0,2.75,0v-1a.625.625,0,1,1,1.25,0Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileXml1: ['file-xml-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.059,17.222a.624.624,0,0,1-.28.838.615.615,0,0,1-.279.066.627.627,0,0,1-.559-.346s-.812-1.623-.847-1.7a.112.112,0,0,0-.184-.007l-.851,1.7a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.305-2.609a.252.252,0,0,0,0-.224L2.941,11.78a.625.625,0,0,1,1.118-.558s.791,1.591.854,1.709.129.09.169.009l.859-1.718a.625.625,0,0,1,1.118.558L5.754,14.389a.252.252,0,0,0,0,.224Zm5.066.279a.625.625,0,0,1-1.25,0V14.566c0-.142-.169-.079-.207-.005l-.109.219a.65.65,0,0,1-1.118,0s-.08-.154-.117-.235-.2-.086-.2.014V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.76,1.533.818,1.635a.148.148,0,0,0,.25-.008l.814-1.627a.625.625,0,0,1,1.184.279Zm4.375.625h-2A1.627,1.627,0,0,1,12.875,16.5v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  CPlusPlus: ['c-plus-plus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-15,9.875a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm6-1.75H12.375a.25.25,0,0,0-.25.25V14a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H9.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V10a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H13.5a.625.625,0,0,1,0,1.25Zm6,0H18.375a.25.25,0,0,0-.25.25V14a.625.625,0,0,1-1.25,0V12.876a.25.25,0,0,0-.25-.25H15.5a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25V10a.625.625,0,1,1,1.25,0v1.125a.25.25,0,0,0,.25.25H19.5a.625.625,0,0,1,0,1.25Z']],
  FileCodeSettings1: ['file-code-settings-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.68,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.687,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.953,8.284a.749.749,0,0,0,0,1.023l2.666,2.857A.751.751,0,0,0,14.68,12.2Z', 'M16.287,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.856a.752.752,0,0,0,0-1.025L17.383,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.415,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V8.357a.245.245,0,0,0,.214.247,7.875,7.875,0,0,1,1.45.318A.247.247,0,0,0,8,8.69V2.5A.5.5,0,0,1,8.5,2H19.38a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.126a.249.249,0,0,0-.236.32,3.229,3.229,0,0,1,.047,1.377.249.249,0,0,0,.24.3H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.415,3Z', 'M4.751 17.032 A1.500 1.500 0 1 0 7.751 17.032 A1.500 1.500 0 1 0 4.751 17.032 Z', 'M12.019,15.655a1.782,1.782,0,0,0-1.7-2.953l-1.41.327a.45.45,0,0,1-.534-.311L7.95,11.326a1.774,1.774,0,0,0-3.4,0l-.424,1.391a.456.456,0,0,1-.533.312L2.184,12.7a1.782,1.782,0,0,0-1.7,2.953l.988,1.064a.464.464,0,0,1,0,.626L.483,18.41a1.783,1.783,0,0,0,1.7,2.953l1.41-.327a.45.45,0,0,1,.534.311l.424,1.392a1.775,1.775,0,0,0,3.4,0l.424-1.392a.45.45,0,0,1,.533-.311l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.988-1.065a.464.464,0,0,1,0-.626ZM6.251,20.032a3,3,0,1,1,3-3A3,3,0,0,1,6.251,20.032Z']],
  FileCodeSettings: ['file-code-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.751,11.532v3.5a.75.75,0,0,0,1.5,0v-3.5a.75.75,0,0,0-1.5,0Z', 'M13,4.282a.75.75,0,0,0-.75.75v3.5a.75.75,0,0,0,1.5,0v-3.5A.75.75,0,0,0,13,4.282Z', 'M20.251,8.032v-2.5A1.252,1.252,0,0,0,19,4.282H17.5a1.252,1.252,0,0,0-1.25,1.25v2.5a1.251,1.251,0,0,0,1.25,1.25H19A1.251,1.251,0,0,0,20.251,8.032Zm-1.5-.5a.25.25,0,0,1-.25.25H18a.25.25,0,0,1-.25-.25v-1.5a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25Z', 'M23.415,3.032,21,.618A2,2,0,0,0,19.586.032H8a2,2,0,0,0-2,2V8.326a.245.245,0,0,0,.214.247,7.875,7.875,0,0,1,1.45.318A.248.248,0,0,0,8,8.658V2.532a.5.5,0,0,1,.5-.5H19.38a.5.5,0,0,1,.353.147L21.855,4.3A.5.5,0,0,1,22,4.653V18.032a.5.5,0,0,1-.5.5H14.142a.25.25,0,0,0-.238.316,3.224,3.224,0,0,1,.022,1.376.25.25,0,0,0,.239.307H22a2,2,0,0,0,2-2V4.447A2,2,0,0,0,23.415,3.032Z', 'M12.019,15.623a1.783,1.783,0,0,0-1.7-2.953L8.908,13a.45.45,0,0,1-.534-.311L7.95,11.294a1.775,1.775,0,0,0-3.4,0l-.424,1.392A.456.456,0,0,1,3.6,13L2.184,12.67a1.783,1.783,0,0,0-1.7,2.953l.988,1.065a.464.464,0,0,1,0,.626L.483,18.378a1.782,1.782,0,0,0,1.7,2.953L3.594,21a.454.454,0,0,1,.534.311l.424,1.392a1.774,1.774,0,0,0,3.4,0l.424-1.391A.454.454,0,0,1,8.907,21l1.411.327a1.782,1.782,0,0,0,1.7-2.953l-.988-1.064a.464.464,0,0,1,0-.626ZM6.251,20a3,3,0,1,1,3-3A3,3,0,0,1,6.251,20Z', 'M4.751 17.001 A1.500 1.500 0 1 0 7.751 17.001 A1.500 1.500 0 1 0 4.751 17.001 Z']],
  Exe: ['exe', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.375,11.376H7.5a.625.625,0,0,1,0,1.25H6.375a.25.25,0,0,0-.25.25V14a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,4.875,14V10A1.625,1.625,0,0,1,6.5,8.376h2a.625.625,0,0,1,0,1.25h-2A.375.375,0,0,0,6.125,10v1.125A.25.25,0,0,0,6.375,11.376Zm7.684,3.346a.625.625,0,1,1-1.118.558l-.854-1.709a.094.094,0,0,0-.175,0l-.853,1.706a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.3-2.609a.252.252,0,0,0,0-.224L9.941,9.28a.625.625,0,1,1,1.118-.558s.806,1.616.84,1.681a.122.122,0,0,0,.2.006l.843-1.687a.625.625,0,1,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm2.316-3.346H17.5a.625.625,0,0,1,0,1.25H16.375a.25.25,0,0,0-.25.25V14a.375.375,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25h-2A1.626,1.626,0,0,1,14.875,14V10A1.625,1.625,0,0,1,16.5,8.376h2a.625.625,0,0,1,0,1.25h-2a.375.375,0,0,0-.375.375v1.125A.25.25,0,0,0,16.375,11.376Z']],
  FileAsp: ['file-asp', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,13.626a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14.5A.876.876,0,0,0,7,13.626Z', 'M17,13.626h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H17a.875.875,0,0,0,0-1.75Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.125,19a.625.625,0,0,1-1.25,0V16.876a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V19a.625.625,0,0,1-1.25,0V14.626a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,14.5Zm2.3-4.133,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Zm5.448,1.758h-.5a.25.25,0,0,0-.25.25V19a.625.625,0,1,1-1.25,0V13a.625.625,0,0,1,.625-.625H17a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,16.875,16.626Z']],
  FileCodeSearch1: ['file-code-search-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.168,19.772a.242.242,0,0,1-.03-.3A5.515,5.515,0,1,0,8.45,21.155a.242.242,0,0,1,.3.031l2.506,2.5a1,1,0,1,0,1.414-1.414ZM5.5,20.017a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,5.5,20.017Z', 'M14.714,6.467a.75.75,0,0,0-1.078-1.042l-.018.018L10.952,8.3a.749.749,0,0,0,0,1.023l2.666,2.857a.751.751,0,0,0,1.061.036L14.7,12.2a.749.749,0,0,0,.018-1.042L12.686,8.983a.25.25,0,0,1,0-.342Z', 'M16.286,11.157A.75.75,0,0,0,17.364,12.2l.017-.018,2.667-2.857a.752.752,0,0,0,0-1.025L17.382,5.443a.752.752,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.175a.249.249,0,0,1,0,.341Z', 'M23.414,3.018,21,.6A2,2,0,0,0,19.586.017H8a2,2,0,0,0-2,2v7.3a.242.242,0,0,0,.222.241,6.991,6.991,0,0,1,1.453.309A.242.242,0,0,0,8,9.642V2.517a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.147l2.122,2.121A.5.5,0,0,1,22,4.639V18.018a.5.5,0,0,1-.5.5H12.382a.242.242,0,0,0-.23.17,6.945,6.945,0,0,1-.386.948.321.321,0,0,0,.033.352l.4.4a.431.431,0,0,0,.346.133H22a2,2,0,0,0,2-2V4.432A2,2,0,0,0,23.414,3.018Z']],
  FileBin1: ['file-bin-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M5.5,12.126H4.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H5.5a.875.875,0,0,0,0-1.75Z', 'M5.5,15.126H4.875a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H5.5a.875.875,0,1,0,0-1.75Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.149,14.662a2.13,2.13,0,0,1,.412,1.867,2.174,2.174,0,0,1-2.137,1.6H4a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,4,10.876H5.424a2.174,2.174,0,0,1,2.137,1.6,2.128,2.128,0,0,1-.412,1.866A.25.25,0,0,0,7.149,14.662Zm3.726,2.214H11a.625.625,0,0,1,0,1.25H9a.625.625,0,0,1,0-1.25h.125a.25.25,0,0,0,.25-.25v-4.25a.25.25,0,0,0-.25-.25H9a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.125a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,10.875,16.876Zm5.75.625a.625.625,0,0,1-.481.608.644.644,0,0,1-.144.017.627.627,0,0,1-.559-.346s-1.631-3.245-1.667-3.334-.149-.067-.149,0V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s1.583,3.187,1.645,3.29.171.094.171-.007v-3a.625.625,0,1,1,1.25,0Z']],
  FileDmg1: ['file-dmg-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M4.456,12.32a.249.249,0,0,0-.331.239v3.883a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,5.875,14.5,2.237,2.237,0,0,0,4.456,12.32Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM3.5,18.126a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm8.625-.625a.625.625,0,0,1-1.25,0V14.574c0-.154-.15-.134-.224.021l-.092.185a.65.65,0,0,1-1.118,0s-.047-.092-.107-.214-.209-.117-.209.008V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.72,1.429.786,1.571a.173.173,0,0,0,.311,0l.785-1.569a.625.625,0,0,1,1.184.279Zm5-4a.625.625,0,0,1-1.25,0V13a.875.875,0,1,0-1.75,0v3a.875.875,0,0,0,1.718.237c.01-.036.033-.112-.085-.112H15.5a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625V16a2.125,2.125,0,0,1-4.25,0V13a2.125,2.125,0,1,1,4.25,0Z']],
  FileJava: ['file-java', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,14.126a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V15A.876.876,0,0,0,19.5,14.126Z', 'M9.5,14.126A.876.876,0,0,0,8.625,15v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V15A.876.876,0,0,0,9.5,14.126Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM6.625,18a2.125,2.125,0,0,1-4.25,0,.625.625,0,0,1,1.25,0,.875.875,0,0,0,1.75,0V13.5a.625.625,0,1,1,1.25,0Zm5,1.5a.625.625,0,0,1-1.25,0V17.376a.25.25,0,0,0-.25-.25H8.875a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V15.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,11.625,15Zm5-4.5A8.178,8.178,0,0,1,15,19.876a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,12.375,15V13.5a.625.625,0,1,1,1.25,0V15a6.918,6.918,0,0,0,.771,3.161.138.138,0,0,0,.213-.01A6.926,6.926,0,0,0,15.375,15V13.5a.625.625,0,1,1,1.25,0Zm5,4.5a.625.625,0,1,1-1.25,0V17.376a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0V15.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,21.625,15Z']],
  Asp1: ['asp-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,12.126A1.377,1.377,0,0,0,5.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,6.5,12.126Z', 'M18.5,12.126H17.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H18.5a1.375,1.375,0,0,0,0-2.75Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.125,19.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H5.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-5.9a2.7,2.7,0,0,1,2.1-2.678A2.629,2.629,0,0,1,9.125,13.5Zm2.68-5.047,1.949.975a2.479,2.479,0,0,1-1.108,4.7H10.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.548-2.329l-1.949-.974a2.48,2.48,0,0,1,1.109-4.7H14.5a.625.625,0,0,1,0,1.25H12.354a1.229,1.229,0,0,0-.549,2.328ZM18.4,16.126H17.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.148A2.7,2.7,0,0,1,18.4,16.126Z']],
  FileApk: ['file-apk', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,13.126A.876.876,0,0,0,6.125,14v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14A.876.876,0,0,0,7,13.126Z', 'M12,13.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H12a.875.875,0,0,0,0-1.75Z', 'M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM9.125,18.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H6.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V14.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.125,14Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H12a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,11.875,16.126Zm4.686-.448,2.381,2.381a.625.625,0,0,1-.884.884S16.4,17.286,16.317,17.2s-.192-.053-.192.041V18.5a.625.625,0,1,1-1.25,0v-6a.625.625,0,1,1,1.25,0V13.77c0,.164.152.069.152.069l1.781-1.78a.625.625,0,0,1,.884.884l-2.381,2.381A.25.25,0,0,0,16.561,15.678Z']],
  FileApk1: ['file-apk-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M10,12.126H9.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H10a.875.875,0,0,0,0-1.75Z', 'M5,12.126A.876.876,0,0,0,4.125,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.875.875,0,0,0,5,12.126Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.125,17.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.126a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,7.125,13Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H10a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,9.875,15.126Zm4.686-.448,2.382,2.381a.625.625,0,0,1-.885.884S14.4,16.286,14.317,16.2s-.192-.053-.192.041V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,1,1,1.25,0V12.77c0,.164.153.069.153.069l1.78-1.78a.625.625,0,1,1,.885.884l-2.382,2.381A.25.25,0,0,0,14.561,14.678Z']],
  FileAsp1: ['file-asp-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,12.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H15a.875.875,0,0,0,0-1.75Z', 'M5,12.126A.876.876,0,0,0,4.125,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.876.876,0,0,0,5,12.126Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.125,17.5a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,7.125,13Zm2.3-4.133,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H8.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,9.8,10.876h1.7a.625.625,0,0,1,0,1.25H9.8a.678.678,0,0,0-.376,1.242Zm5.448,1.758h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H15a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,14.875,15.126Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileCodeCash1: ['file-code-cash-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM7.538,21.178c-.094.024-.288.109-.288.294v.279a.75.75,0,0,1-1.5,0V21.5a.248.248,0,0,0-.248-.247H5a.75.75,0,0,1,0-1.5H7.033a.592.592,0,0,0,.22-1.141L5.19,17.785a2.085,2.085,0,0,1,.344-3.978.334.334,0,0,0,.216-.328v-.228a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25H8a.75.75,0,0,1,0,1.5H5.967a.592.592,0,0,0-.22,1.141l2.063.825a2.084,2.084,0,0,1-.272,3.961Z']],
  FileCodeDisable1: ['file-code-disable-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.5,6.5,0,0,0,6.5,11ZM2.533,19.6a4.448,4.448,0,0,1-.367-3.319,4.5,4.5,0,0,1,3.112-3.117,4.444,4.444,0,0,1,3.325.367.252.252,0,0,1,.052.4L2.931,19.655A.252.252,0,0,1,2.533,19.6Zm8.3-.887a4.5,4.5,0,0,1-3.112,3.116A4.443,4.443,0,0,1,4.4,21.467a.252.252,0,0,1-.052-.4l5.724-5.722a.252.252,0,0,1,.4.051A4.448,4.448,0,0,1,10.834,18.717Z']],
  FileCodeLock1: ['file-code-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.284a.749.749,0,0,0,0,1.023l2.666,2.857A.751.751,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.857a.749.749,0,0,0,0-1.023L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.684a.244.244,0,0,0,.184.235,4.438,4.438,0,0,1,1.429.687A.247.247,0,0,0,8,10.4V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H11.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M8.611,15.513a.123.123,0,0,1-.111-.12V14.251a3.5,3.5,0,1,0-7,0v1.134a.114.114,0,0,1-.113.128A1.5,1.5,0,0,0,0,17v5.5A1.5,1.5,0,0,0,1.5,24h7A1.5,1.5,0,0,0,10,22.5V17A1.5,1.5,0,0,0,8.611,15.513ZM5,21.251a1,1,0,1,1,1-1A1,1,0,0,1,5,21.251Zm1.5-5.866a.12.12,0,0,1-.106.116l-2.782,0a.122.122,0,0,1-.112-.116V14.251a1.5,1.5,0,1,1,3,0Z']],
  FileCodeStar1: ['file-code-star-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.607,17.139a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,11.738,15h-2.5a.25.25,0,0,1-.229-.15L7.664,11.732,7.651,11.7a1.293,1.293,0,0,0-2.317.028L3.988,14.849a.251.251,0,0,1-.23.15h-2.5a1.23,1.23,0,0,0-1.166.76,1.272,1.272,0,0,0,.32,1.4L2.6,19.111a.25.25,0,0,1,.063.286L1.444,22.211a1.253,1.253,0,0,0,.314,1.451,1.359,1.359,0,0,0,1.506.167l3.112-1.753a.249.249,0,0,1,.245,0l3.113,1.753a1.277,1.277,0,0,0,1.506-.167,1.254,1.254,0,0,0,.315-1.45L10.331,19.4a.252.252,0,0,1,.063-.287Z', 'M14.714,6.451a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.284a.749.749,0,0,0,0,1.023l2.666,2.857a.751.751,0,0,0,1.061.036l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.017-.019,2.667-2.857a.749.749,0,0,0,0-1.023L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V8.793a.248.248,0,0,0,.232.249,8.446,8.446,0,0,1,1.452.211A.248.248,0,0,0,8,9.013V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.165a.231.231,0,0,0-.163.06l-1.175,1.06a.279.279,0,0,0-.086.3l.172.4a.308.308,0,0,0,.275.187H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z']],
  FileCodeRemove1: ['file-code-remove-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.232l.018-.018a.749.749,0,0,0,.018-1.042L12.686,9a.249.249,0,0,1,0-.341l2.028-2.174A.75.75,0,0,0,13.636,5.44l-.018.018L10.952,8.315a.751.751,0,0,0,0,1.024L13.618,12.2A.752.752,0,0,0,14.679,12.232Z', 'M16.286,11.172a.75.75,0,0,0,1.078,1.042l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.458a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.25.25,0,0,1,0,.342Z', 'M23.414,3.032,21,.618A2,2,0,0,0,19.586.032H8a2,2,0,0,0-2,2V9.245a.247.247,0,0,0,.242.25c.366.007,1.038.033,1.485.082A.246.246,0,0,0,8,9.329v-6.8a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.147L21.854,4.3A.5.5,0,0,1,22,4.653V18.032a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.209,7.973,7.973,0,0,1-.373,1.458.244.244,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.447A2,2,0,0,0,23.414,3.032Z', 'M6.5,10.97a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,6.5,10.97Zm2.652,9.151a.75.75,0,0,1-1.061,0L6.677,18.707a.25.25,0,0,0-.354,0L4.909,20.121a.75.75,0,1,1-1.06-1.061l1.413-1.414a.249.249,0,0,0,0-.353L3.848,15.879a.75.75,0,0,1,1.061-1.061l1.414,1.414a.25.25,0,0,0,.354,0l1.414-1.414a.75.75,0,0,1,1.06,1.061L7.737,17.293a.25.25,0,0,0,0,.353L9.152,19.06A.752.752,0,0,1,9.152,20.121Z']],
  FileCodeSubtract1: ['file-code-subtract-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.232l.018-.018a.749.749,0,0,0,.018-1.042L12.686,9a.249.249,0,0,1,0-.341l2.028-2.174A.75.75,0,0,0,13.636,5.44l-.018.018L10.952,8.315a.751.751,0,0,0,0,1.024L13.618,12.2A.752.752,0,0,0,14.679,12.232Z', 'M16.286,11.172a.75.75,0,0,0,1.078,1.042l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.458a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.25.25,0,0,1,0,.342Z', 'M23.414,3.032,21,.618A2,2,0,0,0,19.586.032H8a2,2,0,0,0-2,2V9.245a.248.248,0,0,0,.242.25c.366.007,1.038.033,1.485.082A.246.246,0,0,0,8,9.329v-6.8a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.147L21.854,4.3A.5.5,0,0,1,22,4.653V18.032a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.209,7.973,7.973,0,0,1-.373,1.458.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.447A2,2,0,0,0,23.414,3.032Z', 'M6.5,10.97a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,6.5,10.97ZM9,18.22H4a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Z']],
  FileCss1: ['file-css-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM6,16.876a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm2.927-3.508,1.84,1.226A1.928,1.928,0,0,1,9.7,18.126H8a.625.625,0,0,1,0-1.25H9.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,9.3,10.876H11a.625.625,0,0,1,0,1.25H9.3a.678.678,0,0,0-.376,1.242Zm5,0,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H13a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532H16a.625.625,0,0,1,0,1.25H14.3a.678.678,0,0,0-.376,1.242Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileDat1: ['file-dat-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,12.126A.876.876,0,0,0,8.625,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.876.876,0,0,0,9.5,12.126Z', 'M3.956,12.32a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,5.375,14.5,2.237,2.237,0,0,0,3.956,12.32Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM3,18.126a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,3,10.876a3.625,3.625,0,0,1,0,7.25Zm8.625-.625a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H8.875a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,11.625,13ZM17,12.126H15.875a.25.25,0,0,0-.25.25V17.5a.625.625,0,1,1-1.25,0V12.376a.25.25,0,0,0-.25-.25H13a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FilePhp1: ['file-php-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,12.126h-.625a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H15a.875.875,0,0,0,0-1.75Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM4.875,15.126h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H5a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,4.875,15.126Zm7.25,2.375a.625.625,0,0,1-1.25,0V15.376a.25.25,0,0,0-.25-.25H9.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,1,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V11.5a.625.625,0,1,1,1.25,0Zm2.75-2.375h-.5a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,.625-.625H15a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,14.875,15.126Z', 'M5,12.126H4.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H5a.875.875,0,0,0,0-1.75Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileHqx1: ['file-hqx-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z', 'M10,11.626a.876.876,0,0,0-.875.875V15a.875.875,0,0,0,1.75,0V12.5A.876.876,0,0,0,10,11.626Z', 'M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM7.125,17a.625.625,0,0,1-1.25,0V14.876a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V17a.625.625,0,0,1-1.25,0V11a.625.625,0,0,1,1.25,0v2.125a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V11a.625.625,0,1,1,1.25,0Zm5-2a2.112,2.112,0,0,1-.993,1.786c-.029.019-.044.088.029.147l.727.577a.634.634,0,0,1,.1.879.627.627,0,0,1-.878.1l-1.93-1.53A2.126,2.126,0,0,1,7.875,15V12.5a2.125,2.125,0,1,1,4.25,0Zm4.934,1.721a.625.625,0,1,1-1.118.558s-.752-1.5-.814-1.629-.194-.12-.243-.023l-.825,1.652a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.778,1.564.833,1.667a.122.122,0,0,0,.22-.008l.829-1.659a.625.625,0,1,1,1.118.558l-1.305,2.609a.252.252,0,0,0,0,.224Z']],
  FileIso: ['file-iso', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M16.5,13.626a.876.876,0,0,0-.875.875v3a.875.875,0,1,0,1.75,0v-3A.876.876,0,0,0,16.5,13.626Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7ZM7.875,18.376H8a.625.625,0,0,1,0,1.25H6a.625.625,0,0,1,0-1.25h.125a.25.25,0,0,0,.25-.25v-4.25a.25.25,0,0,0-.25-.25H6a.625.625,0,1,1,0-1.25H8a.625.625,0,0,1,0,1.25H7.875a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,7.875,18.376Zm3.052-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532H13a.625.625,0,0,1,0,1.25H11.3a.678.678,0,0,0-.376,1.242Zm7.7,2.633a2.125,2.125,0,1,1-4.25,0v-3a2.125,2.125,0,1,1,4.25,0Z']],
  FileSql: ['file-sql', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.428A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M12.318,13.5a.876.876,0,0,0-.875.875v2.5a.875.875,0,0,0,1.75,0v-2.5A.875.875,0,0,0,12.318,13.5Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.251A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.251A.25.25,0,0,0,21.75,7Zm-15,7.742,1.84,1.226A1.928,1.928,0,0,1,7.516,19.5h-1.7a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.069-3.532h1.7a.625.625,0,0,1,0,1.25h-1.7a.678.678,0,0,0-.376,1.242Zm7.7,2.133a2.112,2.112,0,0,1-.973,1.774.1.1,0,0,0,.009.159l.728.577a.634.634,0,0,1,.1.878.627.627,0,0,1-.879.1l-1.93-1.53a2.128,2.128,0,0,1-1.307-1.96v-2.5a2.125,2.125,0,0,1,4.25,0ZM18.818,19.5h-2a1.627,1.627,0,0,1-1.625-1.625v-5a.625.625,0,1,1,1.25,0v5a.376.376,0,0,0,.375.375h2a.625.625,0,0,1,0,1.25Z']],
  FileIso1: ['file-iso-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM5.875,16.876H6a.625.625,0,0,1,0,1.25H4a.625.625,0,0,1,0-1.25h.125a.25.25,0,0,0,.25-.25v-4.25a.25.25,0,0,0-.25-.25H4a.625.625,0,0,1,0-1.25H6a.625.625,0,0,1,0,1.25H5.875a.25.25,0,0,0-.25.25v4.25A.25.25,0,0,0,5.875,16.876Zm3.052-3.508,1.84,1.226A1.928,1.928,0,0,1,9.7,18.126H8a.625.625,0,0,1,0-1.25H9.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,9.3,10.876H11a.625.625,0,0,1,0,1.25H9.3a.678.678,0,0,0-.376,1.242ZM16.625,16a2.125,2.125,0,0,1-4.25,0V13a2.125,2.125,0,1,1,4.25,0Z', 'M14.5,12.126a.876.876,0,0,0-.875.875v3a.875.875,0,0,0,1.75,0V13A.876.876,0,0,0,14.5,12.126Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  FileYm1: ['file-ym-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM9.625,12.5A2.621,2.621,0,0,1,7.8,14.992a.247.247,0,0,0-.176.233V17.5a.625.625,0,0,1-1.25,0V15.225a.247.247,0,0,0-.177-.233A2.622,2.622,0,0,1,4.375,12.5v-1a.625.625,0,1,1,1.25,0v1a1.375,1.375,0,0,0,2.75,0v-1a.625.625,0,1,1,1.25,0Zm5,5a.625.625,0,0,1-1.25,0V14.546c0-.126-.162-.074-.2,0l-.115.23a.65.65,0,0,1-1.118,0s-.056-.121-.11-.221-.206-.114-.206.011V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.71,1.408.781,1.562a.177.177,0,0,0,.323-.007l.778-1.555a.625.625,0,0,1,1.184.279Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  Hqx1: ['hqx-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,12.126A1.377,1.377,0,0,0,10.125,13.5V17a1.375,1.375,0,0,0,2.75,0V13.5A1.377,1.377,0,0,0,11.5,12.126Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM8.125,19.5a.625.625,0,0,1-1.25,0V16.376a.25.25,0,0,0-.25-.25H4.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,1.25,0v3.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V11.5a.625.625,0,1,1,1.25,0Zm6-2.5a2.61,2.61,0,0,1-1.25,2.221c-.052.032-.081.138.037.207l.9.534a.625.625,0,1,1-.635,1.076s-3.063-1.812-3.082-1.826A2.621,2.621,0,0,1,8.875,17V13.5a2.625,2.625,0,1,1,5.25,0Zm5.934,2.221a.625.625,0,1,1-1.118.558l-1.217-2.435a.25.25,0,0,0-.448,0L16.059,19.78a.625.625,0,0,1-.559.346.625.625,0,0,1-.559-.9l1.8-3.609a.252.252,0,0,0,0-.224l-1.8-3.609a.625.625,0,1,1,1.118-.558l1.217,2.435a.251.251,0,0,0,.448,0l1.217-2.435a.625.625,0,0,1,1.118.558l-1.8,3.609a.252.252,0,0,0,0,.224Z']],
  Java1: ['java-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.021,14.126a.875.875,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V15A.876.876,0,0,0,19.021,14.126Z', 'M9.021,14.126A.875.875,0,0,0,8.146,15v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V15A.876.876,0,0,0,9.021,14.126Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM6.146,18A2.125,2.125,0,0,1,1.9,18a.625.625,0,0,1,1.25,0A.875.875,0,0,0,4.9,18V13.5a.625.625,0,0,1,1.25,0Zm5,1.5a.625.625,0,0,1-1.25,0V17.376a.25.25,0,0,0-.25-.25H8.4a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V15.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,11.146,15Zm5-4.5a8.178,8.178,0,0,1-1.625,4.875.625.625,0,0,1-1,0A8.178,8.178,0,0,1,11.9,15V13.5a.625.625,0,1,1,1.25,0V15a6.918,6.918,0,0,0,.771,3.161.137.137,0,0,0,.212-.01A6.915,6.915,0,0,0,14.9,15V13.5a.625.625,0,1,1,1.25,0Zm5,4.5a.625.625,0,1,1-1.25,0V17.376a.25.25,0,0,0-.25-.25H18.4a.25.25,0,0,0-.25.25V19.5a.625.625,0,1,1-1.25,0V15.126a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,21.146,15Z']],
  FileCsv1: ['file-csv-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H19A1,1,0,0,0,20,19ZM6.5,16.876a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm2.927-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H8.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,9.8,10.876h1.7a.625.625,0,0,1,0,1.25H9.8a.678.678,0,0,0-.376,1.242Zm7.7-.367A8.178,8.178,0,0,1,15.5,17.876a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,12.875,13V11.5a.625.625,0,1,1,1.25,0V13a6.923,6.923,0,0,0,.674,2.965.25.25,0,0,0,.4.014A6.912,6.912,0,0,0,15.875,13V11.5a.625.625,0,1,1,1.25,0Z', 'M23.707,5.708,18.293.294A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2v5.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.751V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.415A1,1,0,0,0,23.707,5.708Z']],
  Csv: ['csv', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-14,9.875a.625.625,0,0,1,0,1.25,3.625,3.625,0,0,1,0-7.25.625.625,0,0,1,0,1.25,2.375,2.375,0,0,0,0,4.75Zm2.927-3.508,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,11.8,8.376h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242Zm7.7-.367A8.178,8.178,0,0,1,17.5,15.376a.625.625,0,0,1-1,0A8.178,8.178,0,0,1,14.875,10.5V9a.625.625,0,1,1,1.25,0v1.5a6.91,6.91,0,0,0,.7,3.014.227.227,0,0,0,.357-.006,6.916,6.916,0,0,0,.7-3.008V9a.625.625,0,1,1,1.25,0Z']],
  FileCodeAdd1: ['file-code-add-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM9,18.251H7.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H4a.75.75,0,0,1,0-1.5H5.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H9a.75.75,0,0,1,0,1.5Z']],
  FileCodeAlternative: ['file-code-alternative', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.707,5.708,16.293.294A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.415A1,1,0,0,0,21.707,5.708ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.147l4.535,4.535A.5.5,0,0,1,20,7.036Z', 'M8.527,13.315a.252.252,0,0,1,0-.342l2.537-2.718A1,1,0,0,0,9.6,8.89L6.27,12.461a1,1,0,0,0,0,1.365L9.6,17.4a1,1,0,0,0,1.414.049l.025-.024a1,1,0,0,0,.023-1.389Z', 'M14.4,8.89a1,1,0,1,0-1.462,1.364l2.537,2.719a.249.249,0,0,1,0,.341l-2.537,2.718a1,1,0,0,0,1.437,1.391L14.4,17.4l3.333-3.571a1,1,0,0,0,0-1.365Z']],
  FileCodeQuestion1: ['file-code-question-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,6.5,22.5Zm.939-4.173a.27.27,0,0,0-.189.273v.15a.75.75,0,0,1-1.5,0V18.2a1.257,1.257,0,0,1,.988-1.222,1.125,1.125,0,1,0-1.363-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,3.564,2.452Z', 'M14.679,12.2l.018-.017a.751.751,0,0,0,.018-1.043L12.686,8.966a.249.249,0,0,1,0-.341l2.028-2.174a.75.75,0,0,0-1.078-1.043l-.018.019L10.952,8.283a.752.752,0,0,0,0,1.025l2.666,2.857A.752.752,0,0,0,14.679,12.2Z', 'M16.286,11.14a.75.75,0,0,0,1.078,1.043l.018-.018,2.666-2.857a.752.752,0,0,0,0-1.025L17.382,5.427a.751.751,0,0,0-1.061-.036.731.731,0,0,0-.036,1.06l2.029,2.174a.249.249,0,0,1,0,.341Z', 'M23.414,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.214a.248.248,0,0,0,.242.25c.366.006,1.038.033,1.485.082A.246.246,0,0,0,8,9.3V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.631a.244.244,0,0,0-.241.208,7.983,7.983,0,0,1-.373,1.459.243.243,0,0,0,.228.332H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z']]
};
exports["default"] = _default;